/* ═════════════════════════════════════════════════════════════
   PDC CONFIGURATEUR — panneaux-de-chantier.com
   ─────────────────────────────────────────────────────────────
   Refonte architecture (29/05/2026) : code dé-minifié, encapsulé
   en module (IIFE), fonctions décomposées, et surtout DÉCOUPLAGE
   HTML/JS via délégation d'événements (data-attributes).
   → Plus AUCUN handler inline (onclick/oninput/…) dans le .liquid.
   Comportement strictement identique à la v6.6 (prix, SVG, panier,
   validation, vocabulaire). Voir le tableau data-action ↔ handler
   en bas de fichier (section WIRING).

   Ordre de chargement (préservé) : pdc-qrcode.min.js PUIS ce
   fichier — on appelle la lib globale `qrcode(...)`.
   ═════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Force l'encodage UTF-8 de la lib QR (accents dans emails/URLs). */
  if (typeof qrcode !== 'undefined' && qrcode.stringToBytesFuncs && qrcode.stringToBytesFuncs['UTF-8']) {
    qrcode.stringToBytes = qrcode.stringToBytesFuncs['UTF-8'];
  }

  /* ═══════════════════════════════════════════════════════════
     1. CONSTANTES (Cloudinary, variantes, prix, mentions légales)
     ═══════════════════════════════════════════════════════════ */
  var CLOUD = 'yxalo-groupe';
  var PRESET = 'pdc_uploads';

  var CREA_VID = 56645542216066;
  var OEIL_VID = 56696929583490;
  var PERC_VID = 56696972378498;

  var BASE_FOLDER = 'pdc-commandes';
  var FOLDERS = { pub: 'pub', permis: 'permis', agent: 'agent', habillage: 'habillage', immo3x2: 'immo' };

  /* Variantes Shopify (38) — clé SKU → variant ID.
     Doit rester synchro avec les variantes du back-office. */
  var VARIANTS = {
    // PUB CHANTIER (16)
    'pub-60x40-pp-10': 56645540479362,
    'pub-60x40-pp-25': 56645540512130,
    'pub-60x40-pp-50': 56645540544898,
    'pub-60x40-pp-100': 56645540577666,
    'pub-60x40-alu-10': 56645540610434,
    'pub-60x40-alu-25': 56645540643202,
    'pub-60x40-alu-50': 56645540675970,
    'pub-60x40-alu-100': 56645540708738,
    'pub-80x120-pp-10': 56645540741506,
    'pub-80x120-pp-25': 56645540774274,
    'pub-80x120-pp-50': 56645540807042,
    'pub-80x120-pp-100': 56645540839810,
    'pub-80x120-alu-10': 56645540872578,
    'pub-80x120-alu-25': 56645540905346,
    'pub-80x120-alu-50': 56645540938114,
    'pub-80x120-alu-100': 56645540970882,
    // PUB 80 × 60 (6) — lots 10/50/100 (pas de lot 25)
    'pub-80x60-pp-10': 56722842616194,
    'pub-80x60-pp-50': 56722842648962,
    'pub-80x60-pp-100': 56722842681730,
    'pub-80x60-alu-10': 56722842714498,
    'pub-80x60-alu-50': 56722842747266,
    'pub-80x60-alu-100': 56722842780034,
    // PERMIS (2) — unité pure (lots 5/10 supprimés en v6.6.1)
    'permis-pp-1': 56645541003650,
    'permis-alu-1': 56645541101954,
    // AGENT IMMOBILIER (12) — lots 10/50/100 (lot 25 retiré)
    'agent-40x60-pp-10': 56645541200258,
    'agent-40x60-pp-50': 56645541265794,
    'agent-40x60-pp-100': 56645541298562,
    'agent-40x60-alu-10': 56645541331330,
    'agent-40x60-alu-50': 56645541396866,
    'agent-40x60-alu-100': 56645541429634,
    'agent-60x80-pp-10': 56645541462402,
    'agent-60x80-pp-50': 56645541527938,
    'agent-60x80-pp-100': 56645541560706,
    'agent-60x80-alu-10': 56645541593474,
    'agent-60x80-alu-50': 56645541659010,
    'agent-60x80-alu-100': 56645541691778,
    // AGENT RECTO-VERSO (12) — PP uniquement, lots 10/50/100 (pas de lot 25).
    // Verso auto = statut permuté : vente (À VENDRE↔VENDU) / location (À LOUER↔LOUÉ).
    'agent-rv-vente-40x60-pp-10': 56676564631938,
    'agent-rv-vente-40x60-pp-50': 56676564697474,
    'agent-rv-vente-40x60-pp-100': 56676564730242,
    'agent-rv-vente-60x80-pp-10': 56676564763010,
    'agent-rv-vente-60x80-pp-50': 56676564828546,
    'agent-rv-vente-60x80-pp-100': 56676564861314,
    'agent-rv-location-40x60-pp-10': 56676564894082,
    'agent-rv-location-40x60-pp-50': 56676564959618,
    'agent-rv-location-40x60-pp-100': 56676564992386,
    'agent-rv-location-60x80-pp-10': 56676565025154,
    'agent-rv-location-60x80-pp-50': 56676565090690,
    'agent-rv-location-60x80-pp-100': 56676565123458,
    // HABILLAGE 1,8 × 1 m (2) — unité pure
    'habillage-pp-1': 56645541953922,
    'habillage-alu-1': 56645542052226,
    // PROMO IMMO 3 × 2 m (2)
    'immo-3x2-pp': 56645542150530,
    'immo-3x2-alu': 56645542183298
  };

  /* Prix € HT — prix TOTAL du variant (table de lookup).
     MAJ tarifaire 26/05/2026, synchro CSV back-office. */
  var PRICING = {
    // PUB
    'pub-60x40-pp-10': 45, 'pub-60x40-pp-25': 76, 'pub-60x40-pp-50': 115, 'pub-60x40-pp-100': 199,
    'pub-60x40-alu-10': 130.5, 'pub-60x40-alu-25': 272, 'pub-60x40-alu-50': 495, 'pub-60x40-alu-100': 900,
    'pub-80x120-pp-10': 89, 'pub-80x120-pp-25': 185, 'pub-80x120-pp-50': 335, 'pub-80x120-pp-100': 599,
    'pub-80x120-alu-10': 405, 'pub-80x120-alu-25': 1087.5, 'pub-80x120-alu-50': 1980, 'pub-80x120-alu-100': 3600,
    'pub-80x60-pp-10': 69, 'pub-80x60-pp-50': 229, 'pub-80x60-pp-100': 439,
    'pub-80x60-alu-10': 280, 'pub-80x60-alu-50': 1280, 'pub-80x60-alu-100': 2350,
    // PERMIS — unité pure
    'permis-pp-1': 60,
    'permis-alu-1': 90,
    // AGENT — lots 10/50/100 (lot 25 retiré)
    'agent-40x60-pp-10': 35, 'agent-40x60-pp-50': 90, 'agent-40x60-pp-100': 160,
    'agent-40x60-alu-10': 130.5, 'agent-40x60-alu-50': 495, 'agent-40x60-alu-100': 900,
    'agent-60x80-pp-10': 45, 'agent-60x80-pp-50': 170, 'agent-60x80-pp-100': 300,
    'agent-60x80-alu-10': 206, 'agent-60x80-alu-50': 995, 'agent-60x80-alu-100': 2000,
    // AGENT RECTO-VERSO (= prix recto PP × 1,4 ; vente et location au même prix)
    'agent-rv-vente-40x60-pp-10': 49, 'agent-rv-vente-40x60-pp-50': 126, 'agent-rv-vente-40x60-pp-100': 224,
    'agent-rv-vente-60x80-pp-10': 63, 'agent-rv-vente-60x80-pp-50': 238, 'agent-rv-vente-60x80-pp-100': 420,
    'agent-rv-location-40x60-pp-10': 49, 'agent-rv-location-40x60-pp-50': 126, 'agent-rv-location-40x60-pp-100': 224,
    'agent-rv-location-60x80-pp-10': 63, 'agent-rv-location-60x80-pp-50': 238, 'agent-rv-location-60x80-pp-100': 420,
    // HABILLAGE
    'habillage-pp-1': 60,
    'habillage-alu-1': 110,
    // IMMO 3×2
    'immo-3x2-pp': 180, 'immo-3x2-alu': 315
  };

  var RECOURS = "Droit de recours : Le délai de recours contentieux est de deux mois à compter du premier jour d'une période continue de deux mois d'affichage sur le terrain du présent panneau (art R600-2 du code de l'urbanisme). Tout recours administratif ou tout recours contentieux doit, à peine d'irrecevabilité, être notifié à l'auteur de la décision et au bénéficiaire du permis ou de la décision prise sur la déclaration préalable. Cette notification doit être adressée par lettre recommandée avec accusé de réception dans un délai de quinze jours francs à compter du dépôt du recours (art. R600-1 du code de l'urbanisme). Arrêté du 11 Septembre 2007.";

  /* ═══ Variantes d'autorisation d'urbanisme (A424-15 : mêmes règles d'affichage pour toutes) ═══
     titre = bandeau ; numLbl = libellé du n° ; rows = lignes conditionnelles du formulaire guidé. */
  var PM_TYPES = {
    pc:  { titre: 'PERMIS DE CONSTRUIRE',             numLbl: 'PERMIS N°',       numPh: 'PC 073 000 21 00123', surf: true,  haut: true,  demol: true,  lots: false },
    pcm: { titre: 'PERMIS DE CONSTRUIRE MODIFICATIF', numLbl: 'PERMIS N°',       numPh: 'PC 073 000 21 00123 M01', surf: true, haut: true, demol: true, lots: false },
    pa:  { titre: "PERMIS D'AMÉNAGER",                numLbl: 'PERMIS N°',       numPh: 'PA 073 000 21 00123', surf: false, haut: false, demol: false, lots: true },
    pd:  { titre: 'PERMIS DE DÉMOLIR',                numLbl: 'PERMIS N°',       numPh: 'PD 073 000 21 00123', surf: false, haut: false, demol: true,  lots: false },
    dp:  { titre: 'DÉCLARATION PRÉALABLE',            numLbl: 'DÉCLARATION N°',  numPh: 'DP 073 000 21 00123', surf: true,  haut: true,  demol: false, lots: false }
  };
  function pmType() { return PM_TYPES[state.pm.type] || PM_TYPES.pc; }

  /* Liste [libellé, valeur] des champs du panneau selon le type (A424-16 : nature du projet
     obligatoire pour tous ; lots pour lotissement ; surface/hauteur pour constructions ;
     surface à démolir pour démolitions). Partagée aperçu + fichier d'impression. */
  function pmFields() {
    var t = pmType(), pm = state.pm;
    var f = [
      [(t.numLbl === 'DÉCLARATION N°' ? 'N° de déclaration :' : 'N° de Permis :'), pm.num],
      ['En date du :', pm.ddate],
      ['Bénéficiaire :', pm.nom + (pm.rs ? ' — ' + pm.rs : '')],
      ['Architecte :', pm.archi],
      ['Nature du projet :', pm.nature]
    ];
    if (t.surf) f.push(['Superficie de plancher autorisée :', pm.surf ? pm.surf + ' m²' : '']);
    if (t.haut) f.push(['Hauteur de la/les construction(s) :', pm.haut ? pm.haut + ' m' : '']);
    if (t.demol) f.push(['Surface de bâtiments à démolir :', pm.demol ? pm.demol + ' m²' : '']);
    if (t.lots) f.push(['Nombre maximum de lots prévus :', pm.lots]);
    if (t.lots && pm.empl) f.push(['Nombre total d\'emplacements :', pm.empl]); /* camping / PRL (A424-16) */
    f.push(['Superficie du terrain :', pm.terrain ? pm.terrain + ' m²' : '']);
    f.push(['Dossier consultable en Mairie de :', pm.mairie]);
    f.push(['Date d\'affichage en mairie :', pm.dmairie]);
    return f;
  }

  /* ═══════════════════════════════════════════════════════════
     2. ÉTAT (state) — source de vérité de la configuration
     ═══════════════════════════════════════════════════════════ */
  var state = {
    cat: 'pub', habType: 'habillage', mode: 'file', pmMode: 'file', aMode: 'file', mask: 'classique', habLater: false,
    ori: 'paysage', immoOri: 'paysage',
    fw: 60, fh: 40, mat: 'pp', matN: 'PP alvéolaire 3,5 mm',
    lot: 10,        // lot sélectionné (10/25/50/100 pub-agent ; 1 permis-habillage ; null immo)
    cartQty: 1,     // qty envoyée à /cart/add.js pour la variante principale
    bgCol: '#FFFFFF', txtCol: '#111111',
    nom: '', activites: '', slogan: '', tel: '', mail: '', web: '',
    // Designer IA (mode 'ia' catégorie pub) — saisie formulaire + génération courante
    iaNom: '', iaMetier: '', iaVille: '', iaTel: '', iaEmail: '', iaPrestas: '', iaEnvies: '',
    iaCouleur: '', iaStyle: 'auto', iaRefManque: '', iaRefPicto: '', iaLogo: '', iaLogoColor: '',
    ia: { id: null, props: [], chosen: -1, busy: false, autoSaved: false },
    pmBanCol: '#111111', pmTxtCol: '#F5C800',
    pm: { type: 'pc', nom: '', rs: '', nature: '', lots: '', empl: '', surf: '', haut: '', demol: '', num: '', ddate: '', dmairie: '', mairie: '', archi: '', terrain: '' },
    agency: { nom: '', tel: '', mail: '', web: '' },
    aBgCol: '#1A4C8B', aTxtCol: '#FFFFFF',
    qte_av: 10, qte_al: 0, qte_vd: 0,
    rv: false,      // recto-verso agent immo (verso = statut permuté, voir §R/V)
    aOri: 'paysage', // orientation agent immo : paysage | portrait (n'affecte pas la variante/prix)
    crea: false, oeillets: false,
    creaBrief: '', creaFiles: [],
    promo: '', promoApplied: false,
    // Fichiers importés (url = dataURL aperçu ; file = File brut ; ratio = w/h image)
    logo: { url: '', file: null, name: '' },
    pubf: { url: '', file: null, name: '' },
    pmlogo: { url: '', file: null, name: '' },
    pmf: { url: '', file: null, name: '' },
    alogo: { url: '', file: null, name: '' },
    aFile: { url: '', file: null, name: '' },       // agent recto (mode fichier)
    aFileVerso: { url: '', file: null, name: '' },  // agent verso (mode fichier + R/V)
    habf: { url: '', file: null, name: '' },
    immof: { url: '', file: null, name: '' }
  };

  /* ═══════════════════════════════════════════════════════════
     3. HELPERS GÉNÉRIQUES
     ═══════════════════════════════════════════════════════════ */
  function byId(id) { return document.getElementById(id); }

  /* Tronque une chaîne à n caractères (sans suffixe). */
  function clip(s, n) {
    if (!s) return '';
    return s.length > n ? s.substring(0, n) : s;
  }

  /* Affecte une valeur à un chemin d'état "champ" ou "objet.champ". */
  function setStatePath(path, value) {
    var parts = path.split('.');
    if (parts.length === 2) state[parts[0]][parts[1]] = value;
    else state[path] = value;
  }

  var cats = {
    pub: 'Panneau publicitaire',
    permis: 'Permis de construire',
    agent: 'Panneau agent immobilier',
    habillage: 'Habillage chantier'
  };
  /* Libellé catégorie courant (habillage devient "Promotion immobilière" en 3×2). */
  function catLabel() {
    if (state.cat === 'habillage' && state.habType === 'immo3x2') return 'Promotion immobilière';
    return cats[state.cat];
  }

  /* ═══════════════════════════════════════════════════════════
     4. DÉRIVÉS : SKU / variant / prix / quantités / labels / validation
     ═══════════════════════════════════════════════════════════ */
  function getSku() {
    if (state.cat === 'pub') return 'pub-' + state.fw + 'x' + state.fh + '-' + state.mat + '-' + state.lot;
    if (state.cat === 'permis') return 'permis-' + state.mat + '-' + state.lot;
    if (state.cat === 'agent') {
      if (rvActive()) return 'agent-rv-' + rvSide() + '-' + state.fw + 'x' + state.fh + '-pp-' + state.lot;
      return 'agent-' + state.fw + 'x' + state.fh + '-' + state.mat + '-' + state.lot;
    }
    if (state.cat === 'habillage') {
      if (state.habType === 'habillage') return 'habillage-' + state.mat + '-' + state.lot;
      if (state.habType === 'immo3x2') return 'immo-3x2-' + state.mat;
    }
    return null;
  }
  function getVID() {
    var sku = getSku();
    return sku ? VARIANTS[sku] : null;
  }
  function getVariantPrice() {
    var sku = getSku();
    return (sku && PRICING[sku] !== undefined) ? PRICING[sku] : 0;
  }
  function isDevis() {
    return state.cat === 'habillage' && state.habType === 'devis';
  }

  /* Mode simulateur/guidé : c'est la maquette SVG composée qui est le visuel à imprimer.
     En mode « j'ai mon fichier » (et habillage/immo), c'est le fichier client qui prime
     → on ne joint PAS la maquette SVG (inutile pour l'atelier). */
  function isGuidedMode() {
    /* mode IA : la maquette SVG (sans filigrane) est aussi le visuel à imprimer */
    if (state.cat === 'pub') return state.mode === 'guide' || (state.mode === 'ia' && state.ia.chosen >= 0);
    if (state.cat === 'permis') return state.pmMode === 'guide';
    if (state.cat === 'agent') return state.aMode === 'guide';
    return false; // habillage / immo : toujours un visuel client
  }

  /* ─── RECTO-VERSO (agent immo) ───────────────────────────────
     Dispo si : agent + PP + lot ∈ {10,50,100} + lot homogène
     (tout À VENDRE → vente, ou tout À LOUER → location).
     Verso auto = statut permuté : VENDRE↔VENDU, LOUER↔LOUÉ.
     Prix = recto PP × 1,4 (porté par les variantes Shopify dédiées). */
  function rvLotOk() { return [10, 50, 100].indexOf(state.lot) !== -1; }
  function rvSide() {
    if (state.qte_av === state.lot && state.qte_al === 0 && state.qte_vd === 0) return 'vente';
    if (state.qte_al === state.lot && state.qte_av === 0 && state.qte_vd === 0) return 'location';
    return null;
  }
  function rvAvailable() {
    return state.cat === 'agent' && state.mat === 'pp' && rvLotOk() && rvSide() !== null;
  }
  function rvActive() { return state.rv && rvAvailable(); }
  function rvStatuses() {
    return rvSide() === 'location' ? { recto: 'À LOUER', verso: 'LOUÉ' } : { recto: 'À VENDRE', verso: 'VENDU' };
  }
  function rvReason() {
    if (state.cat !== 'agent') return '';
    if (state.mat !== 'pp') return 'Recto-verso disponible uniquement en PP alvéolaire';
    if (!rvLotOk()) return 'Recto-verso disponible pour les lots 10, 50 et 100';
    if (rvSide() === null) return 'Recto-verso nécessite un lot homogène (tout À VENDRE ou tout À LOUER)';
    return '';
  }

  /* Nombre total de panneaux physiques (≠ qty Shopify pour les lots). */
  function totalPanneaux() {
    if (state.cat === 'pub') return state.lot * state.cartQty;
    if (state.cat === 'agent') return state.lot;
    if (state.cat === 'permis') return state.lot === 1 ? state.cartQty : state.lot;
    if (state.cat === 'habillage') {
      if (state.habType === 'habillage') return state.lot === 1 ? state.cartQty : state.lot;
      if (state.habType === 'immo3x2') return state.cartQty;
    }
    return 1;
  }

  /* Calcule total / sous-total / qty Shopify. */
  function calcPrice() {
    var unitVariant = getVariantPrice();
    // Cas "unité multipliée" : permis ou habillage en unité (lot=1) avec sélecteur de quantité.
    var isUnitMulti = (state.cat === 'permis' || (state.cat === 'habillage' && state.habType === 'habillage')) && state.lot === 1;
    var isPubMulti = state.cat === 'pub'; // lots Pub multipliables (2×10, 3×10…)
    var qtyForPrice = (state.cat === 'habillage' && state.habType === 'immo3x2') ? state.cartQty : ((isUnitMulti || isPubMulti) ? state.cartQty : 1);
    var subtotal = unitVariant * qtyForPrice;
    var total = subtotal;
    if (state.crea) total += 50;
    if (state.oeillets) total += 2 * totalPanneaux();
    if (state.promoApplied) total = Math.round(total * 0.9);
    return { total: total, subtotal: subtotal, unitVariant: unitVariant, qtyForPrice: qtyForPrice };
  }

  function fmtLabel() {
    if (state.cat === 'habillage') {
      if (state.habType === 'habillage') return '1,80 × 1,00 m (module)';
      if (state.habType === 'immo3x2') return state.immoOri === 'paysage' ? '3 × 2 m (paysage)' : '2 × 3 m (portrait)';
      return '—';
    }
    if (state.cat === 'agent') return state.fw + ' × ' + state.fh + ' cm';
    if (state.cat === 'permis') return '80 × 120 cm';
    // Paysage = côté long en largeur, côté court en hauteur (et inversement en portrait).
    var w = state.ori === 'paysage' ? Math.max(state.fw, state.fh) : Math.min(state.fw, state.fh);
    var h = state.ori === 'paysage' ? Math.min(state.fw, state.fh) : Math.max(state.fw, state.fh);
    return (w && h) ? w + ' × ' + h + ' cm (' + state.ori + ')' : '—';
  }

  /* Remise du gros badge prix, calculée sur le prix/u réel vs lot de 10. */
  function discLabel() {
    if ((state.cat === 'pub' || state.cat === 'agent') && state.lot > 10) {
      var sku = state.cat + '-' + state.fw + 'x' + state.fh + '-' + state.mat + '-';
      var base = PRICING[sku + '10'];
      var cur = PRICING[sku + state.lot];
      if (base !== undefined && cur !== undefined) {
        var disc = Math.round((1 - (cur / state.lot) / (base / 10)) * 100);
        return disc > 0 ? '-' + disc + '%' : '';
      }
    }
    return '';
  }

  function validate() {
    /* Config REPRISE : le fichier n'est plus en mémoire (state.X.file = null) mais son
       URL Cloudinary est conservée (state.X.cloud) → on l'accepte comme fichier fourni. */
    if (state.cat === 'pub') {
      if (state.mode === 'guide') return !!(state.nom || state.logo.file || state.logo.cloud);
      if (state.mode === 'later') return true;
      if (state.mode === 'ia') return state.ia.chosen >= 0;
      return !!(state.pubf.file || state.pubf.cloud);
    }
    if (state.cat === 'permis') {
      if (state.pmMode === 'guide') return !!(state.pm.nom || state.pm.num);
      if (state.pmMode === 'later') return true;
      return !!(state.pmf.file || state.pmf.cloud);
    }
    if (state.cat === 'agent') {
      if ((state.qte_av + state.qte_al + state.qte_vd) !== state.lot) return false;
      if (state.aMode === 'later') return true;
      if (state.aMode === 'file') {
        if (!state.aFile.file && !state.aFile.cloud) return false;
        if (rvActive() && !state.aFileVerso.file && !state.aFileVerso.cloud) return false;
        return true;
      }
      return !!(state.agency.nom || state.alogo.file || state.alogo.cloud);
    }
    if (state.cat === 'habillage') {
      if (state.habType === 'devis') return false;
      if (state.habLater) return true;
      if (state.habType === 'habillage') return !!(state.habf.file || state.habf.cloud);
      if (state.habType === 'immo3x2') return !!(state.immof.file || state.immof.cloud);
      return false;
    }
    return false;
  }

  /* ═══════════════════════════════════════════════════════════
     5. CLOUDINARY (upload des sources + maquette)
     ═══════════════════════════════════════════════════════════ */
  // Jeton unique par commande (généré dans addCart) — évite toute collision de noms
  // de fichiers entre clients (ex. deux « client » le même jour, même format).
  var batchId = '';
  function newBatchId() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }
  function cloudId(type) {
    var d = new Date().toISOString().slice(0, 10);
    var cat = state.cat.toUpperCase();
    var fmt;
    if (state.cat === 'habillage' && state.habType === 'habillage') fmt = '180x100';
    else if (state.cat === 'habillage' && state.habType === 'immo3x2') fmt = '300x200';
    else fmt = state.fw + 'x' + state.fh;
    var nom = (state.nom || state.pm.nom || state.agency.nom || 'client').replace(/[^a-zA-Z0-9]/g, '').slice(0, 20) || 'client';
    var uid = batchId || newBatchId();
    return d + '_' + cat + '_' + fmt + '_' + state.mat.toUpperCase() + '_' + nom + '_' + type + '_' + uid;
  }
  function upload(file, type, subfolder) {
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', PRESET);
    var cat = state.cat === 'habillage' ? (FOLDERS[state.habType] || FOLDERS.habillage) : FOLDERS[state.cat];
    var sub = subfolder || 'sources';
    var folder = BASE_FOLDER + '/' + cat + '/' + sub;
    fd.append('folder', folder);
    fd.append('public_id', cloudId(type));
    return fetch('https://api.cloudinary.com/v1_1/' + CLOUD + '/auto/upload', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('Upload ' + r.status);
        return r.json();
      })
      .then(function (j) { return j.secure_url; });
  }

  /* Échappe une valeur pour insertion dans le XML de la maquette d'impression. */
  function escXml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ═══ Maquette d'IMPRESSION permis (mode guidé) ═══
     Fichier machine : 80×120 cm portrait + 3 mm de fond perdu = 806×1206 mm,
     unités = mm réels. Cadre et bandeaux DÉBORDENT dans le fond perdu
     (tournant 3 mm, pas de filet blanc à la coupe). L'aperçu écran
     (svgPermis, viewBox 200×300) reste inchangé : lui n'est PAS imprimable.
     Centrage des titres : x = (W − textLength)/2 + ancrage gauche —
     JAMAIS text-anchor=middle avec textLength (décalage Chrome/RIP). */
  function svgPermisPrint() {
    var B = 3, PW = 800, PH = 1200, FR = 8;
    var W = PW + 2 * B, H = PH + 2 * B;
    var bc = state.pmBanCol, bt = state.pmTxtCol, pm = state.pm;
    var h = '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="' + bc + '"/>' +
      '<rect x="' + (B + FR) + '" y="' + (B + FR) + '" width="' + (PW - 2 * FR) + '" height="' + (PH - 2 * FR) + '" fill="#ffffff"/>';

    h += '<rect x="' + (24 + B) + '" y="' + (24 + B) + '" width="752" height="208" rx="12" fill="#f7f7f5"/>';
    if (state.pmlogo.url) h += '<image href="' + escXml(state.pmlogo.url) + '" x="' + (40 + B) + '" y="' + (32 + B) + '" width="720" height="192" preserveAspectRatio="xMidYMid meet"/>';

    var banY = 240 + B;
    var titre = pmType().titre;
    /* Titre : longueur verrouillée (jamais text-anchor=middle avec textLength) ;
       corps réduit si le titre est long (ex. PC MODIFICATIF) */
    var tLen = Math.min(700, Math.max(520, titre.length * 24));
    var tFs = Math.min(34, Math.floor(tLen / (titre.length * 0.68)));
    h += '<rect x="0" y="' + banY + '" width="' + W + '" height="72" fill="' + bc + '"/>' +
      '<text x="' + ((W - tLen) / 2) + '" y="' + (banY + 48) + '" font-size="' + tFs + '" font-weight="900" fill="' + bt + '" font-family="Arial Black, Arial" textLength="' + tLen + '" lengthAdjust="spacingAndGlyphs">' + escXml(titre) + '</text>';

    var fields = pmFields();
    var startY = banY + 88;
    var rowH = Math.min(62, Math.floor((944 - startY) / Math.max(1, fields.length)));
    fields.forEach(function (f, i) {
      var fy = startY + i * rowH;
      h += '<text x="' + (40 + B) + '" y="' + fy + '" font-size="16" fill="#555" font-family="Arial" font-weight="700">' + escXml(f[0]) + '</text>' +
        '<line x1="' + (40 + B) + '" y1="' + (fy + 34) + '" x2="' + (760 + B) + '" y2="' + (fy + 34) + '" stroke="#b9b9b9" stroke-width="1.4" stroke-dasharray="6 4"/>';
      if (f[1]) h += '<text x="' + (48 + B) + '" y="' + (fy + 28) + '" font-size="19" fill="#111" font-family="Arial" font-weight="700">' + escXml(f[1]) + '</text>';
    });

    var legY = startY + fields.length * rowH + 4;
    h += '<line x1="' + (32 + B) + '" y1="' + legY + '" x2="' + (768 + B) + '" y2="' + legY + '" stroke="#cccccc" stroke-width="1.2"/>';
    wrapText(RECOURS, 126).forEach(function (l, i) {
      h += '<text x="' + (W / 2) + '" y="' + (legY + 20 + i * 13.5) + '" text-anchor="middle" font-size="9.5" fill="#777" font-family="Arial">' + escXml(l) + '</text>';
    });

    /* Bandeau bas + bloc pub PDC : QR vers le site (chaque panneau posé = une pub scannable) */
    var botTop = 1076 + B;
    h += '<rect x="0" y="' + botTop + '" width="' + W + '" height="' + (H - botTop) + '" fill="' + bc + '"/>';
    var qrSize = 84, qrX = W - 8 - qrSize - 14, qrY = botTop + Math.round(((H - botTop) - qrSize) / 2) - 6;
    var qr = pdcQrPath('https://panneaux-de-chantier.com/?utm_source=panneau&utm_medium=qr&utm_campaign=permis', qrX, qrY, qrSize);
    var txTL = 560, txCx = qr ? (8 + (qrX - 8) / 2) : W / 2;
    h += '<text x="' + (txCx - txTL / 2) + '" y="' + (botTop + 66) + '" font-size="30" font-weight="900" fill="' + bt + '" font-family="Arial Black, Arial" textLength="' + txTL + '" lengthAdjust="spacingAndGlyphs">CHANTIER INTERDIT AU PUBLIC</text>' +
      '<text x="' + txCx + '" y="' + (botTop + 100) + '" text-anchor="middle" font-size="16" font-weight="700" fill="rgba(255,255,255,.85)" font-family="Arial">panneaux-de-chantier.com</text>';
    if (qr) {
      h += qr;
      h += '<text x="' + (qrX + qrSize / 2) + '" y="' + (qrY + qrSize + 13) + '" text-anchor="middle" font-size="9" fill="rgba(255,255,255,.7)" font-family="Arial">Commandez le vôtre</text>';
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + W + 'mm" height="' + H + 'mm" viewBox="0 0 ' + W + ' ' + H + '">' + h + '</svg>';
  }

  /* QR vectoriel générique (carte blanche + modules noirs), '' si la lib est absente. */
  function pdcQrPath(data, x, y, size) {
    if (typeof qrcode === 'undefined') return '';
    try {
      var q = qrcode(0, 'M');
      q.addData(data);
      q.make();
      var n = q.getModuleCount(), quiet = 2, total = n + quiet * 2, m = size / total, path = '';
      for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) {
        if (q.isDark(r, c)) path += 'M' + (x + (c + quiet) * m).toFixed(2) + ',' + (y + (r + quiet) * m).toFixed(2) + 'h' + m.toFixed(2) + 'v' + m.toFixed(2) + 'h-' + m.toFixed(2) + 'z';
      }
      return '<rect x="' + x + '" y="' + y + '" width="' + size + '" height="' + size + '" rx="4" fill="#ffffff"/><path d="' + path + '" fill="#000000"/>';
    } catch (e) { return ''; }
  }

  /* Snapshot du SVG composé en live (QR déjà vectoriels → maquette atelier autonome). */
  function getMaquetteSVG() {
    /* Mode IA : maquette générée proprement par le moteur (SANS le filigrane d'aperçu) */
    if (state.cat === 'pub' && state.mode === 'ia' && state.ia.chosen >= 0 && window.PDC_DESIGNER) {
      var full = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n' +
        PDC_DESIGNER.render(state.ia.props[state.ia.chosen], iaContact(), { watermark: false, logo: state.iaLogo, logoColor: state.iaLogoColor, ratio: iaRatio() });
      return new File([new Blob([full], { type: 'image/svg+xml' })], 'maquette-design-ia.svg', { type: 'image/svg+xml' });
    }
    /* Permis en mode guidé : maquette d'IMPRESSION à l'échelle (806×1206 mm, fond perdu 3 mm) */
    if (state.cat === 'permis' && state.pmMode === 'guide') {
      var fullPm = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n' + svgPermisPrint();
      return new File([new Blob([fullPm], { type: 'image/svg+xml' })], 'maquette-permis-impression-806x1206-fp3.svg', { type: 'image/svg+xml' });
    }
    var svg = byId('pdc-sv');
    if (!svg || !svg.innerHTML.trim()) return null;
    var clone = svg.cloneNode(true);
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    var xml = new XMLSerializer().serializeToString(clone);
    var full = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n' + xml;
    var blob = new Blob([full], { type: 'image/svg+xml' });
    return new File([blob], 'maquette.svg', { type: 'image/svg+xml' });
  }

  /* ═══════════════════════════════════════════════════════════
     6. CONTRÔLE DPI (qualité fichier importé)
     ═══════════════════════════════════════════════════════════ */
  function dpiCheck(iw, ih, pw, ph) {
    var d = Math.min(iw / (pw / 2.54), ih / (ph / 2.54));
    if (d >= 150) return { d: Math.round(d), v: '✓ Qualité OK', c: 'ok', t: Math.round(d) + ' DPI — impression directe' };
    if (d >= 72) return { d: Math.round(d), v: '⚠ Qualité moyenne', c: 'warn', t: Math.round(d) + ' DPI — acceptable grand format' };
    return { d: Math.round(d), v: '✗ Résolution insuffisante', c: 'error', t: Math.round(d) + ' DPI — à reprendre' };
  }
  function showDPI(pfx, iw, ih, pw, ph) {
    var b = byId(pfx + '-qb');
    if (!b) return;
    var q = dpiCheck(iw, ih, pw, ph);
    b.className = 'qb-d-box ' + q.c;
    b.style.display = '';
    byId(pfx + '-qv').textContent = q.v;
    byId(pfx + '-qd').textContent = q.t + ' · ' + iw + '×' + ih + 'px pour ' + pw + '×' + ph + 'cm';
  }

  /* ═══════════════════════════════════════════════════════════
     7. GÉNÉRATION QR CODE (SVG vectoriel natif)
     ─────────────────────────────────────────────────────────────
     data    : chaîne encodée (tel:/mailto:/https://…)
     x, y    : coin haut-gauche dans le viewBox
     size    : côté du QR (carré) en unités viewBox
     vbW     : largeur viewBox du panneau (calc DPI/scannabilité)
     panneauW: largeur physique panneau en cm (calc DPI/scannabilité)
     color   : couleur des modules (forcé #000 par les moteurs SVG
               pour garantir la scannabilité fond noir/texte clair)
     ═══════════════════════════════════════════════════════════ */
  function qrSVG(data, x, y, size, vbW, panneauW, color) {
    if (!data || !data.trim()) return '';
    color = color || '#000';
    try {
      // Type 0 = auto-détection version, niveau de correction 'M' (~15%).
      var q = qrcode(0, 'M');
      q.addData(data);
      q.make();
      var n = q.getModuleCount();
      var quietZone = 2; // marge blanche (norme 4, resserrée pour l'aperçu)
      var totalModules = n + quietZone * 2;
      var moduleSize = size / totalModules;
      // Warning console si le QR imprimé fait < 2,5 cm (scannabilité compromise).
      if (vbW && panneauW) {
        var sizeCm = (size / vbW) * panneauW;
        if (sizeCm < 2.5) console.warn('[qrSVG] QR taille ' + sizeCm.toFixed(1) + ' cm sur panneau — en dessous de 2,5 cm la scannabilité est compromise.');
      }
      var path = '';
      for (var r = 0; r < n; r++) {
        for (var c = 0; c < n; c++) {
          if (q.isDark(r, c)) {
            var px = x + (c + quietZone) * moduleSize;
            var py = y + (r + quietZone) * moduleSize;
            path += 'M' + px.toFixed(3) + ',' + py.toFixed(3) + 'h' + moduleSize.toFixed(3) + 'v' + moduleSize.toFixed(3) + 'h-' + moduleSize.toFixed(3) + 'z';
          }
        }
      }
      return '<g><rect x="' + x.toFixed(3) + '" y="' + y.toFixed(3) + '" width="' + size.toFixed(3) + '" height="' + size.toFixed(3) + '" fill="#fff"/><path d="' + path + '" fill="' + color + '"/></g>';
    } catch (e) {
      console.error('[qrSVG] Erreur génération QR :', e);
      // Fallback visuel : carré rayé rouge pour signaler l'erreur.
      return '<g><rect x="' + x.toFixed(3) + '" y="' + y.toFixed(3) + '" width="' + size.toFixed(3) + '" height="' + size.toFixed(3) + '" fill="#fff" stroke="#c00" stroke-width="0.5"/><text x="' + (x + size / 2) + '" y="' + (y + size / 2) + '" text-anchor="middle" dominant-baseline="central" font-size="' + (size * 0.18) + '" fill="#c00" font-family="Arial">QR</text></g>';
    }
  }

  function wrapText(txt, maxChars) {
    var words = txt.split(' ');
    var lines = [];
    var cur = '';
    words.forEach(function (w) {
      if ((cur + ' ' + w).trim().length > maxChars) {
        lines.push(cur.trim());
        cur = w;
      } else {
        cur += ' ' + w;
      }
    });
    if (cur.trim()) lines.push(cur.trim());
    return lines;
  }

  /* ═══════════════════════════════════════════════════════════
     8. MOTEURS SVG (un par catégorie) + dispatcher renderSVG()
     ═══════════════════════════════════════════════════════════ */
  function renderSVG() {
    var s = byId('pdc-sv');
    if (state.cat === 'pub') svgPub(s);
    else if (state.cat === 'permis') svgPermis(s);
    else if (state.cat === 'agent') svgAgent(s);
    else if (state.cat === 'habillage') {
      if (state.habType === 'habillage') svgHabillage(s);
      else if (state.habType === 'immo3x2') svgImmo(s);
      else s.innerHTML = '<rect width="200" height="150" fill="#f4f3f1"/><text x="100" y="80" text-anchor="middle" font-size="10" fill="#999">Sur devis</text>';
    }
  }

  /* Ratio h/w du format courant pour le designer IA (IA = paysage) : 2/3 pour 60×40 et 120×80, 3/4 pour 80×60 */
  function iaRatio() {
    var l = Math.max(state.fw, state.fh) || 60, s = Math.min(state.fw, state.fh) || 40;
    return s / l;
  }

  function svgPub(sv) {
    /* viewBox au VRAI ratio du format (80×60 = 4:3, 60×40 et 120×80 = 3:2…) — l'aperçu ne ment plus */
    var isPay = state.ori === 'paysage';
    var lngV = Math.max(state.fw, state.fh) || 60, shtV = Math.min(state.fw, state.fh) || 40;
    var sideV = Math.round(300 * shtV / lngV);
    var vw = isPay ? 300 : sideV, vh = isPay ? sideV : 300;
    var wPhys = isPay ? Math.max(state.fw, state.fh) : Math.min(state.fw, state.fh);
    sv.setAttribute('viewBox', '0 0 ' + vw + ' ' + vh);
    sv.style.maxWidth = Math.round(wPhys * 2.83) + 'px';
    var bg = state.bgCol, tc = state.txtCol, lzF = bg === '#FFFFFF' ? '#f7f7f5' : 'rgba(255,255,255,.12)';
    var acts = (state.activites || '').split('\n').filter(Boolean).slice(0, 5);
    var contacts = [
      state.tel ? { val: state.tel, data: 'tel:' + state.tel.replace(/\s/g, '') } : null,
      state.mail ? { val: state.mail, data: 'mailto:' + state.mail } : null,
      state.web ? { val: state.web, data: (state.web.startsWith('http') ? state.web : 'https://' + state.web) } : null
    ].filter(Boolean);
    var h = '<rect x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" rx="4" fill="' + bg + '" stroke="#ddd" stroke-width="1"/>';

    if (state.mode === 'ia') {
      if (state.ia.chosen >= 0 && window.PDC_DESIGNER) {
        sv.setAttribute('viewBox', '0 0 ' + PDC_DESIGNER.W + ' ' + Math.round(PDC_DESIGNER.W * iaRatio()));
        sv.innerHTML = PDC_DESIGNER.renderInner(state.ia.props[state.ia.chosen], iaContact(), { watermark: true, logo: state.iaLogo, logoColor: state.iaLogoColor, ratio: iaRatio() });
      } else {
        sv.innerHTML = h + '<text x="' + (vw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="8" fill="#999" font-family="Arial">✨ Générez votre design avec l\'IA</text>';
      }
      return;
    }

    if (state.mode === 'file' || state.mode === 'later') {
      if (state.mode === 'later') h += '<text x="' + (vw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="8" fill="#999" font-family="Arial">📧 Fichier envoyé par email</text>';
      else if (state.pubf.url) h += '<image href="' + state.pubf.url + '" x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" preserveAspectRatio="xMidYMid slice"/>';
      else if (state.pubf.name) h += '<text x="' + (vw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="8" fill="#999" font-family="Arial">📄 ' + clip(state.pubf.name, 28) + '</text>';
      else h += '<text x="' + (vw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="9" fill="#ccc" font-family="Arial">Importez votre fichier</text>';
      sv.innerHTML = h;
      return;
    }

    if (state.mask === 'classique') {
      var hasLogo = !!state.logo.url;
      var lRatio = hasLogo ? (state.logo.ratio || 1) : 1;
      var isPortraitLogo = hasLogo && lRatio < 0.85;
      var useHorizontal = hasLogo && !isPortraitLogo; // carré ou paysage → horizontal

      var padX = 8;
      var yCnt = isPay ? vh - 44 : vh - 78;
      var ySlo = vh - 6;

      if (useHorizontal) {
        // ─── LAYOUT HORIZONTAL : logo à gauche, nom + activités à droite ───
        var logoZoneW = isPay ? vw * 0.34 : vw * 0.42;
        var logoZoneH = isPay ? vh * 0.55 : vh * 0.35;
        var logoY = isPay ? (vh * 0.5 - logoZoneH / 2 - 10) : (vh * 0.4 - logoZoneH / 2);
        h += '<image href="' + state.logo.url + '" x="' + padX + '" y="' + logoY + '" width="' + (logoZoneW - padX) + '" height="' + logoZoneH + '" preserveAspectRatio="xMidYMid meet"/>';
        var contentX = logoZoneW + 10;
        var cy = isPay ? 34 : 28;
        h += '<text x="' + contentX + '" y="' + cy + '" dominant-baseline="hanging" font-size="' + (isPay ? 12 : 10) + '" font-weight="900" fill="' + tc + '" font-family="Arial Black,Arial">' + clip(state.nom || 'NOM ENTREPRISE', isPay ? 20 : 14) + '</text>';
        cy += (isPay ? 16 : 13);
        h += '<line x1="' + contentX + '" y1="' + cy + '" x2="' + (vw - padX) + '" y2="' + cy + '" stroke="#F5C800" stroke-width="1.5"/>';
        cy += 8;
        acts.forEach(function (a, i) { h += '<text x="' + contentX + '" y="' + (cy + i * 10) + '" dominant-baseline="hanging" font-size="7" fill="' + tc + '" opacity="0.9" font-family="Arial" font-weight="600">● ' + clip(a, isPay ? 22 : 14) + '</text>'; });
      } else {
        // ─── LAYOUT VERTICAL : logo en haut, nom + activités dessous ───
        var yLogo = 5;
        var hLogo = isPay ? vh * 0.30 : vh * 0.22;
        var gapAfterLogo = isPortraitLogo ? 22 : 14;
        var yNomTop = yLogo + hLogo + gapAfterLogo;
        var fzNom = isPay ? 13 : 11;
        if (!hasLogo) {
          h += '<rect x="' + padX + '" y="' + yLogo + '" width="' + (vw - padX * 2) + '" height="' + hLogo + '" rx="3" fill="' + lzF + '"/>';
          h += '<text x="' + (vw / 2) + '" y="' + (yLogo + hLogo / 2) + '" text-anchor="middle" dominant-baseline="central" font-size="10" fill="#ccc" font-family="Arial">LOGO</text>';
        } else {
          h += '<image href="' + state.logo.url + '" x="' + padX + '" y="' + yLogo + '" width="' + (vw - padX * 2) + '" height="' + hLogo + '" preserveAspectRatio="xMidYMid meet"/>';
        }
        // Nom (baseline=hanging pour ne pas chevaucher le logo)
        h += '<text x="' + (vw / 2) + '" y="' + yNomTop + '" text-anchor="middle" dominant-baseline="hanging" font-size="' + fzNom + '" font-weight="900" fill="' + tc + '" font-family="Arial Black,Arial">' + clip(state.nom || 'NOM ENTREPRISE', isPay ? 28 : 22) + '</text>';
        var yLine = yNomTop + fzNom + 3;
        h += '<line x1="20" y1="' + yLine + '" x2="' + (vw - 20) + '" y2="' + yLine + '" stroke="#F5C800" stroke-width="1.5"/>';
        var yActs = yLine + 6;
        acts.forEach(function (a, i) { h += '<text x="' + (vw / 2) + '" y="' + (yActs + i * 10) + '" dominant-baseline="hanging" text-anchor="middle" font-size="7" fill="' + tc + '" opacity="0.9" font-family="Arial" font-weight="600">● ' + clip(a, isPay ? 34 : 24) + '</text>'; });
      }

      // ─── Contacts + QR SVG natif ───
      if (isPay && contacts.length) {
        var nPay = contacts.length, swPay = Math.floor((vw - 20) / nPay);
        contacts.forEach(function (c, i) {
          var cx = 10 + swPay * i + swPay / 2;
          h += '<text x="' + cx + '" y="' + (yCnt - 2) + '" text-anchor="middle" font-size="6.5" fill="' + tc + '" font-family="Arial" font-weight="700">' + clip(c.val, 20) + '</text>';
          h += qrSVG(c.data, cx - 12, yCnt + 2, 24, vw, wPhys, '#000'); // 24×24
        });
      }
      if (!isPay && contacts.length) {
        contacts.forEach(function (c, i) {
          var iy = yCnt + i * 22;
          h += qrSVG(c.data, 12, iy, 20, vw, wPhys, '#000'); // 20×20, ancré à gauche
          h += '<text x="38" y="' + (iy + 12) + '" font-size="7.5" fill="' + tc + '" font-family="Arial" font-weight="700">' + clip(c.val, 24) + '</text>';
        });
      }
      // Slogan
      if (state.slogan) {
        h += '<line x1="20" y1="' + (ySlo - 9) + '" x2="' + (vw - 20) + '" y2="' + (ySlo - 9) + '" stroke="#F5C800" stroke-width="1"/>';
        h += '<text x="' + (vw / 2) + '" y="' + (ySlo - 1) + '" text-anchor="middle" font-size="6.5" font-style="italic" fill="' + tc + '" opacity="0.65" font-family="Arial">' + clip(state.slogan, isPay ? 42 : 28) + '</text>';
      }
    } else if (state.mask === 'bandeau') {
      var bw = isPay ? vw * 0.28 : vw * 0.32;
      h += '<rect x="1" y="1" width="' + bw + '" height="' + (vh - 2) + '" rx="4" fill="' + lzF + '"/>';
      if (state.logo.url) h += '<image href="' + state.logo.url + '" x="4" y="' + (vh / 2 - bw * 0.6) + '" width="' + (bw - 8) + '" height="' + (bw * 1.2) + '" preserveAspectRatio="xMidYMid meet"/>';
      else h += '<text x="' + (bw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="9" fill="#ccc" font-family="Arial">LOGO</text>';
      var cxB = bw + 12;
      h += '<text x="' + cxB + '" y="24" font-size="' + (isPay ? 11 : 9) + '" font-weight="900" fill="' + tc + '" font-family="Arial Black,Arial">' + clip(state.nom || 'NOM', isPay ? 20 : 16) + '</text>';
      h += '<line x1="' + cxB + '" y1="31" x2="' + (vw - 10) + '" y2="31" stroke="#F5C800" stroke-width="1.5"/>';
      acts.forEach(function (a, i) { h += '<text x="' + cxB + '" y="' + (44 + i * 11) + '" font-size="7" fill="' + tc + '" font-family="Arial" font-weight="600">● ' + clip(a, isPay ? 22 : 14) + '</text>'; });
      contacts.forEach(function (c, i) { h += '<text x="' + cxB + '" y="' + (vh - 38 + i * 12) + '" font-size="7" fill="' + tc + '" font-family="Arial" font-weight="700" opacity="0.85">' + clip(c.val, isPay ? 24 : 18) + '</text>'; });
      if (contacts.length) {
        var qx = vw - 32;
        contacts.slice(0, 2).forEach(function (c, i) { h += qrSVG(c.data, qx, vh - 48 + i * 22, 18, vw, wPhys, '#000'); });
      }
    } else if (state.mask === 'impact') {
      var lw = isPay ? vw * 0.38 : vw * 0.55, lh = isPay ? vh * 0.5 : vh * 0.35;
      var lx = (vw - lw) / 2, ly = isPay ? 12 : 20;
      h += '<rect x="' + lx + '" y="' + ly + '" width="' + lw + '" height="' + lh + '" rx="4" fill="' + lzF + '"/>';
      if (state.logo.url) h += '<image href="' + state.logo.url + '" x="' + lx + '" y="' + ly + '" width="' + lw + '" height="' + lh + '" preserveAspectRatio="xMidYMid meet"/>';
      else h += '<text x="' + (vw / 2) + '" y="' + (ly + lh / 2) + '" text-anchor="middle" dominant-baseline="central" font-size="12" fill="#ccc" font-family="Arial">LOGO</text>';
      h += '<text x="' + (vw / 2) + '" y="' + (ly + lh + 20) + '" text-anchor="middle" font-size="' + (isPay ? 14 : 11) + '" font-weight="900" fill="' + tc + '" font-family="Arial Black">' + clip(state.nom || 'NOM', isPay ? 22 : 18) + '</text>';
      var cTxt = contacts.map(function (c) { return c.val; }).join(' · ');
      h += '<text x="' + (vw / 2) + '" y="' + (vh - 12) + '" text-anchor="middle" font-size="6.5" fill="' + tc + '" opacity="0.75" font-family="Arial" font-weight="600">' + clip(cTxt, isPay ? 50 : 30) + '</text>';
    } else if (state.mask === 'coordonnees') {
      if (state.logo.url) h += '<image href="' + state.logo.url + '" x="8" y="8" width="50" height="28" preserveAspectRatio="xMidYMid meet"/>';
      else h += '<rect x="8" y="8" width="50" height="28" rx="3" fill="' + lzF + '"/><text x="33" y="24" text-anchor="middle" font-size="7" fill="#ccc" font-family="Arial">LOGO</text>';
      h += '<text x="' + (isPay ? 68 : 8) + '" y="' + (isPay ? 20 : 50) + '" font-size="' + (isPay ? 11 : 10) + '" font-weight="900" fill="' + tc + '" font-family="Arial Black">' + clip(state.nom || 'NOM', isPay ? 24 : 22) + '</text>';
      if (acts.length) h += '<text x="' + (isPay ? 68 : 8) + '" y="' + (isPay ? 32 : 62) + '" font-size="6.5" fill="' + tc + '" opacity="0.75" font-family="Arial">' + acts.map(function (a) { return clip(a, 16); }).join(' · ') + '</text>';
      h += '<line x1="8" y1="' + (isPay ? 42 : 72) + '" x2="' + (vw - 8) + '" y2="' + (isPay ? 42 : 72) + '" stroke="#F5C800" stroke-width="1.5"/>';
      if (isPay) {
        var nC = contacts.length || 1, swC = Math.floor((vw - 16) / nC), qyC = vh - 55;
        contacts.forEach(function (c, i) {
          var cx = 8 + swC * i + swC / 2;
          h += '<text x="' + cx + '" y="' + (qyC + 2) + '" text-anchor="middle" font-size="7.5" fill="' + tc + '" font-family="Arial" font-weight="800">' + clip(c.val, 18) + '</text>';
          h += qrSVG(c.data, cx - 14, qyC + 8, 28, vw, wPhys, '#000'); // 28×28
        });
      } else {
        var qyP = 86;
        contacts.forEach(function (c, i) {
          var iy = qyP + i * 38;
          h += qrSVG(c.data, 15, iy, 28, vw, wPhys, '#000'); // 28×28
          h += '<text x="50" y="' + (iy + 16) + '" font-size="8.5" fill="' + tc + '" font-family="Arial" font-weight="800">' + clip(c.val, 20) + '</text>';
        });
      }
      if (state.slogan) h += '<text x="' + (vw / 2) + '" y="' + (vh - 6) + '" text-anchor="middle" font-size="6" font-style="italic" fill="' + tc + '" opacity="0.65" font-family="Arial">' + clip(state.slogan, isPay ? 44 : 28) + '</text>';
    }
    h += '<text x="' + (vw - 8) + '" y="' + (vh - 3) + '" text-anchor="end" font-size="4.5" fill="rgba(150,150,150,.5)" font-family="Arial">panneaux-de-chantier.com</text>';
    sv.innerHTML = h;
  }

  function svgPermis(sv) {
    sv.setAttribute('viewBox', '0 0 200 300');
    sv.style.maxWidth = '220px';
    var bc = state.pmBanCol, bt = state.pmTxtCol, pm = state.pm;
    var h = '<rect x="1" y="1" width="198" height="298" rx="3" fill="#fff" stroke="' + bc + '" stroke-width="2"/>';

    if (state.pmMode === 'file' || state.pmMode === 'later') {
      if (state.pmMode === 'later') h += '<text x="100" y="130" text-anchor="middle" font-size="8" fill="#999" font-family="Arial">📧 Fichier envoyé par email</text>';
      else if (state.pmf.url) h += '<image href="' + state.pmf.url + '" x="1" y="1" width="198" height="260" preserveAspectRatio="xMidYMid meet"/>';
      else if (state.pmf.name) h += '<text x="100" y="130" text-anchor="middle" font-size="8" fill="#999" font-family="Arial">📄 ' + clip(state.pmf.name, 24) + '</text>';
      else h += '<text x="100" y="130" text-anchor="middle" font-size="9" fill="#ccc" font-family="Arial">Importez votre fichier</text>';
      h += '<rect x="1" y="268" width="198" height="31" fill="' + bc + '"/>';
      h += '<text x="100" y="287" text-anchor="middle" font-size="7.5" font-weight="900" fill="' + bt + '" font-family="Arial Black" letter-spacing="1">CHANTIER INTERDIT AU PUBLIC</text>';
      h += '<text x="100" y="295" text-anchor="middle" font-size="4" fill="rgba(255,255,255,.75)" font-family="Arial" font-weight="700">panneaux-de-chantier.com</text>';
      sv.innerHTML = h;
      return;
    }

    var logoH = 52;
    h += '<rect x="6" y="6" width="188" height="' + logoH + '" rx="3" fill="#f7f7f5"/>';
    if (state.pmlogo.url) {
      h += '<image href="' + state.pmlogo.url + '" x="10" y="8" width="180" height="' + (logoH - 4) + '" preserveAspectRatio="xMidYMid meet"/>';
    } else {
      h += '<text x="100" y="26" text-anchor="middle" font-size="8" fill="#bbb" font-family="Arial" font-weight="700">votre logo</text>';
      h += '<text x="100" y="38" text-anchor="middle" font-size="5.5" fill="#ccc" font-family="Arial">ou votre texte ici</text>';
    }
    var banY = logoH + 8;
    var titre = pmType().titre;
    var tFs = Math.min(8, Math.floor(170 / (titre.length * 0.72) * 10) / 10);
    h += '<rect x="1" y="' + banY + '" width="198" height="18" fill="' + bc + '"/>';
    h += '<text x="100" y="' + (banY + 13) + '" text-anchor="middle" font-size="' + tFs + '" font-weight="900" fill="' + bt + '" font-family="Arial Black" letter-spacing="1.5">' + titre + '</text>';
    var startY = banY + 22;
    var fields = pmFields();
    var rowH = Math.min(15.5, Math.floor((236 - startY) / Math.max(1, fields.length) * 10) / 10);
    fields.forEach(function (f, i) {
      var fy = startY + i * rowH;
      h += '<text x="10" y="' + (fy + 4) + '" font-size="4" fill="#666" font-family="Arial" font-weight="700">' + f[0] + '</text>';
      h += '<line x1="10" y1="' + (fy + 12) + '" x2="190" y2="' + (fy + 12) + '" stroke="#ccc" stroke-width="0.4" stroke-dasharray="1.5 1"/>';
      if (f[1]) h += '<text x="12" y="' + (fy + 11) + '" font-size="4.5" fill="#111" font-family="Arial" font-weight="600">' + clip(f[1], 40) + '</text>';
    });
    var legY = startY + fields.length * rowH + 3;
    h += '<line x1="8" y1="' + legY + '" x2="192" y2="' + legY + '" stroke="#ddd" stroke-width="0.3"/>';
    var legLines = wrapText(RECOURS, 68);
    legLines.slice(0, 3).forEach(function (l, i) { h += '<text x="100" y="' + (legY + 5 + i * 4) + '" text-anchor="middle" font-size="2.6" fill="#aaa" font-family="Arial">' + l + '</text>'; });
    h += '<rect x="1" y="268" width="198" height="31" fill="' + bc + '"/>';
    h += '<text x="88" y="285" text-anchor="middle" font-size="6.8" font-weight="900" fill="' + bt + '" font-family="Arial Black" letter-spacing="0.8">CHANTIER INTERDIT AU PUBLIC</text>';
    h += '<text x="88" y="294" text-anchor="middle" font-size="4" fill="rgba(255,255,255,.75)" font-family="Arial" font-weight="700">panneaux-de-chantier.com</text>';
    h += pdcQrPath('https://panneaux-de-chantier.com/?utm_source=panneau&utm_medium=qr&utm_campaign=permis', 172, 271.5, 24);
    sv.innerHTML = h;
  }

  function svgAgent(sv) {
    if (state.aMode === 'later') {
      sv.setAttribute('viewBox', '0 0 200 150');
      sv.style.maxWidth = '220px';
      sv.innerHTML = '<rect x="1" y="1" width="198" height="148" rx="3" fill="#f4f3f1" stroke="#ddd"/><text x="100" y="78" text-anchor="middle" font-size="9" fill="#999" font-family="Arial">📧 Fichiers envoyés par email</text>';
      return;
    }
    // Mode fichier : aperçu du visuel recto importé (au format/orientation choisis).
    if (state.aMode === 'file') {
      var lngF = Math.max(state.fw, state.fh), shtF = Math.min(state.fw, state.fh);
      var pw = state.aOri === 'portrait' ? shtF : lngF;
      var ph = state.aOri === 'portrait' ? lngF : shtF;
      var fvw = pw * 5, fvh = ph * 5;
      sv.setAttribute('viewBox', '0 0 ' + fvw + ' ' + fvh);
      sv.style.maxWidth = Math.round(pw * 2.83) + 'px';
      var out = '<rect x="1" y="1" width="' + (fvw - 2) + '" height="' + (fvh - 2) + '" rx="6" fill="#fff" stroke="#ddd" stroke-width="1.5"/>';
      if (state.aFile.url) out += '<image href="' + state.aFile.url + '" x="1" y="1" width="' + (fvw - 2) + '" height="' + (fvh - 2) + '" preserveAspectRatio="xMidYMid slice"/>';
      else if (state.aFile.name) out += '<text x="' + (fvw / 2) + '" y="' + (fvh / 2) + '" text-anchor="middle" font-size="14" fill="#999" font-family="Arial">📄 ' + clip(state.aFile.name, 24) + '</text>';
      else out += '<text x="' + (fvw / 2) + '" y="' + (fvh / 2) + '" text-anchor="middle" font-size="13" fill="#ccc" font-family="Arial">Importez votre fichier recto</text>';
      if (rvActive()) {
        out += '<rect x="' + (fvw - 92) + '" y="10" width="84" height="20" rx="4" fill="#F5C800"/>';
        out += '<text x="' + (fvw - 50) + '" y="24" text-anchor="middle" font-size="11" font-weight="900" fill="#111" font-family="Arial Black">RECTO/VERSO</text>';
      }
      sv.innerHTML = out;
      return;
    }
    var isLg = state.fw === 60;
    var isPortrait = state.aOri === 'portrait';
    var lng = isLg ? 80 : 60, sht = isLg ? 60 : 40, SC = 4;
    var vw = isPortrait ? sht * SC : lng * SC;
    var vh = isPortrait ? lng * SC : sht * SC;
    sv.setAttribute('viewBox', '0 0 ' + vw + ' ' + vh);
    sv.style.maxWidth = Math.round(vw * 1.08) + 'px';
    var bg = state.aBgCol, tc = state.aTxtCol;
    var statut = 'À VENDRE';
    if (state.qte_av > 0) statut = 'À VENDRE';
    else if (state.qte_al > 0) statut = 'À LOUER';
    else if (state.qte_vd > 0) statut = 'VENDU';
    var h = '<rect x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" rx="4" fill="' + bg + '" stroke="#aaa" stroke-width="1"/>';
    var banH = Math.floor(vh * (isPortrait ? 0.26 : 0.35));
    var stF = isPortrait ? (isLg ? 22 : 17) : (isLg ? 28 : 22);
    h += '<rect x="1" y="1" width="' + (vw - 2) + '" height="' + banH + '" fill="rgba(0,0,0,.10)"/>';
    h += '<text x="' + (vw / 2) + '" y="' + (banH / 2 + 8) + '" text-anchor="middle" font-size="' + stF + '" font-weight="900" fill="' + tc + '" font-family="Arial Black" letter-spacing="2">' + statut + '</text>';
    if (isPortrait) {
      // ─── Disposition PORTRAIT : empilée et centrée ───
      var lw = vw * 0.52, lh = lw * 0.6, lx = (vw - lw) / 2, ly = banH + vh * 0.05;
      if (state.alogo.url) h += '<image href="' + state.alogo.url + '" x="' + lx + '" y="' + ly + '" width="' + lw + '" height="' + lh + '" preserveAspectRatio="xMidYMid meet"/>';
      else h += '<rect x="' + lx + '" y="' + ly + '" width="' + lw + '" height="' + lh + '" rx="3" fill="rgba(255,255,255,.2)"/><text x="' + (vw / 2) + '" y="' + (ly + lh / 2 + 3) + '" text-anchor="middle" font-size="8" fill="' + tc + '" opacity=".6" font-family="Arial">LOGO</text>';
      var cy = ly + lh + 22;
      if (state.agency.nom) { h += '<text x="' + (vw / 2) + '" y="' + cy + '" text-anchor="middle" font-size="' + (isLg ? 13 : 11) + '" font-weight="900" fill="' + tc + '" font-family="Arial Black">' + clip(state.agency.nom, isLg ? 22 : 16) + '</text>'; cy += 16; }
      if (state.agency.tel) { h += '<text x="' + (vw / 2) + '" y="' + cy + '" text-anchor="middle" font-size="9.5" font-weight="700" fill="' + tc + '" font-family="Arial">Tél. ' + clip(state.agency.tel, 18) + '</text>'; cy += 12; }
      if (state.agency.web) { h += '<text x="' + (vw / 2) + '" y="' + cy + '" text-anchor="middle" font-size="8.5" fill="' + tc + '" font-family="Arial" opacity=".85">' + clip(state.agency.web, 22) + '</text>'; }
    } else {
      // ─── Disposition PAYSAGE : logo à gauche, infos à droite ───
      if (state.alogo.url) h += '<image href="' + state.alogo.url + '" x="8" y="' + (banH + 8) + '" width="60" height="40" preserveAspectRatio="xMidYMid meet"/>';
      else h += '<rect x="8" y="' + (banH + 8) + '" width="60" height="40" rx="3" fill="rgba(255,255,255,.2)"/><text x="38" y="' + (banH + 30) + '" text-anchor="middle" font-size="7" fill="' + tc + '" font-family="Arial" opacity=".6">LOGO</text>';
      var cx = 80, cyl = banH + 14;
      if (state.agency.nom) { h += '<text x="' + cx + '" y="' + cyl + '" font-size="' + (isLg ? 12 : 10) + '" font-weight="900" fill="' + tc + '" font-family="Arial Black">' + clip(state.agency.nom, isLg ? 28 : 22) + '</text>'; cyl += 14; }
      if (state.agency.tel) { h += '<text x="' + cx + '" y="' + cyl + '" font-size="9" font-weight="700" fill="' + tc + '" font-family="Arial">Tél. ' + clip(state.agency.tel, 18) + '</text>'; cyl += 11; }
      if (state.agency.web) { h += '<text x="' + cx + '" y="' + cyl + '" font-size="8" fill="' + tc + '" font-family="Arial" opacity=".85">' + clip(state.agency.web, 22) + '</text>'; }
    }
    if (rvActive()) {
      var st = rvStatuses();
      h += '<rect x="' + (vw - 70) + '" y="6" width="64" height="14" rx="3" fill="#F5C800"/>';
      h += '<text x="' + (vw - 38) + '" y="16" text-anchor="middle" font-size="8" font-weight="900" fill="#111" font-family="Arial Black">RECTO/VERSO</text>';
      h += '<text x="6" y="' + (vh - 12) + '" font-size="6" fill="' + tc + '" opacity=".75" font-family="Arial" font-weight="700">Verso auto : ' + st.verso + '</text>';
    }
    h += '<text x="' + (vw - 6) + '" y="' + (vh - 3) + '" text-anchor="end" font-size="4" fill="rgba(255,255,255,.3)" font-family="Arial">panneaux-de-chantier.com</text>';
    sv.innerHTML = h;
  }

  function svgHabillage(sv) {
    var vw = 120, vh = 216;
    sv.setAttribute('viewBox', '0 0 ' + vw + ' ' + vh);
    sv.style.maxWidth = '160px';
    var h = '<defs><pattern id="herasG" width="14" height="14" patternUnits="userSpaceOnUse"><path d="M0 0h14v14H0z" fill="#1a1a1a"/><path d="M0 7h14M7 0v14" stroke="rgba(245,200,0,.08)" stroke-width=".5"/></pattern></defs>';
    h += '<rect x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" rx="3" fill="url(#herasG)" stroke="#333" stroke-width="1"/>';
    if (state.habf.url) {
      h += '<rect x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" rx="3" fill="#fff"/>';
      h += '<image href="' + state.habf.url + '" x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" preserveAspectRatio="xMidYMid meet"/>';
    } else if (state.habf.name) {
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="6" fill="#bbb" font-family="Arial">📄 ' + clip(state.habf.name, 18) + '</text>';
    } else {
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2 - 12) + '" text-anchor="middle" font-size="9" font-weight="900" fill="rgba(255,255,255,.7)" font-family="Arial Black">MODULE</text>';
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2) + '" text-anchor="middle" font-size="11" font-weight="900" fill="#F5C800" font-family="Arial Black">1,80 × 1,00 m</text>';
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2 + 14) + '" text-anchor="middle" font-size="6" fill="rgba(255,255,255,.5)" font-family="Arial">Habillage Heras / palissade</text>';
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2 + 24) + '" text-anchor="middle" font-size="5.5" fill="rgba(255,255,255,.4)" font-family="Arial">Importez votre visuel</text>';
    }
    [12, vw - 12].forEach(function (x) { [12, vh - 12].forEach(function (y) { h += '<circle cx="' + x + '" cy="' + y + '" r="2.5" fill="none" stroke="rgba(245,200,0,.6)" stroke-width="1"/>'; }); });
    h += '<text x="' + (vw - 4) + '" y="' + (vh - 3) + '" text-anchor="end" font-size="3.5" fill="rgba(255,255,255,.3)" font-family="Arial">panneaux-de-chantier.com</text>';
    sv.innerHTML = h;
  }

  function svgImmo(sv) {
    var isPay = state.immoOri === 'paysage', vw = isPay ? 300 : 200, vh = isPay ? 200 : 300;
    sv.setAttribute('viewBox', '0 0 ' + vw + ' ' + vh);
    sv.style.maxWidth = isPay ? '340px' : '220px';
    var h = '<rect x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" rx="4" fill="#1A4C8B" stroke="#111" stroke-width="1"/>';
    h += '<defs><clipPath id="ic"><rect x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" rx="4"/></clipPath></defs>';
    if (state.immof.url) {
      h += '<image href="' + state.immof.url + '" x="1" y="1" width="' + (vw - 2) + '" height="' + (vh - 2) + '" preserveAspectRatio="xMidYMid meet" clip-path="url(#ic)"/>';
    } else {
      if (isPay) h += '<line x1="' + (vw / 2) + '" y1="1" x2="' + (vw / 2) + '" y2="' + vh + '" stroke="rgba(255,255,255,.2)" stroke-width="1" stroke-dasharray="4 3"/>';
      else h += '<line x1="1" y1="' + (vh / 2) + '" x2="' + vw + '" y2="' + (vh / 2) + '" stroke="rgba(255,255,255,.2)" stroke-width="1" stroke-dasharray="4 3"/>';
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2 - 10) + '" text-anchor="middle" font-size="10" font-weight="900" fill="#fff" font-family="Arial Black">PANNEAU ' + (isPay ? '3 × 2' : '2 × 3') + ' m</text>';
      h += '<text x="' + (vw / 2) + '" y="' + (vh / 2 + 6) + '" text-anchor="middle" font-size="7" fill="rgba(255,255,255,.6)" font-family="Arial">2 parties · Assemblage sur site</text>';
      if (state.immof.name) h += '<text x="' + (vw / 2) + '" y="' + (vh / 2 + 22) + '" text-anchor="middle" font-size="7" fill="rgba(255,255,255,.4)" font-family="Arial">📄 ' + clip(state.immof.name, 24) + '</text>';
    }
    h += '<text x="' + (vw / 2) + '" y="' + (vh - 5) + '" text-anchor="middle" font-size="5" fill="rgba(255,255,255,.3)" font-family="Arial">panneaux-de-chantier.com</text>';
    sv.innerHTML = h;
  }

  /* ═══════════════════════════════════════════════════════════
     9. RENDER — repeint l'UI depuis l'état.
     Découpé en sous-fonctions ; render() = point d'entrée unique
     (tout ce qui modifiait l'état appelle render()).
     ═══════════════════════════════════════════════════════════ */
  function render() {
    var price = calcPrice();
    refreshPackPrices();
    renderRv();
    // Zone d'upload verso : visible seulement en agent + mode fichier + R/V actif
    var versoCol = byId('aFileVerso-col');
    if (versoCol) versoCol.style.display = (state.cat === 'agent' && state.aMode === 'file' && rvActive()) ? '' : 'none';
    renderPrice(price);
    renderCounters();
    renderPort();
    renderButton();
    byId('val-warn').style.display = 'none';
    renderSVG();
  }

  /* Prix dégressif affiché sur les pastilles de lot (pub + agent). */
  function refreshPackPrices() {
    [['#pub-packs', 'pub'], ['#agent-packs', 'agent']].forEach(function (pair) {
      var sel = pair[0], cat = pair[1];
      var pills = document.querySelectorAll(sel + ' .pack-pill');
      if (!pills.length) return;
      var skuFor = function (q) { return cat + '-' + state.fw + 'x' + state.fh + '-' + state.mat + '-' + q; };
      var baseQ = 10;
      var basePrice = PRICING[skuFor(baseQ)];
      var basePU = (basePrice !== undefined) ? basePrice / baseQ : null;
      pills.forEach(function (p) {
        var q = parseInt(p.dataset.q);
        var price = PRICING[skuFor(q)];
        var elP = p.querySelector('.pack-price');
        if (elP && price !== undefined) elP.textContent = price.toLocaleString('fr-FR') + ' €';
        var elD = p.querySelector('.pack-disc');
        if (elD) {
          var txt = '';
          if (basePU && price !== undefined && q > baseQ) {
            var disc = Math.round((1 - (price / q) / basePU) * 100);
            if (disc > 0) txt = '−' + disc + '%';
          }
          elD.textContent = txt;
          elD.style.display = txt ? 'block' : 'none';
        }
      });
    });
  }

  function renderPrice(price) {
    var total = price.total, subtotal = price.subtotal;
    var fl = fmtLabel();
    var nPann = totalPanneaux();

    byId('price-v').textContent = total.toLocaleString('fr-FR') + ' €';
    if (state.promoApplied) {
      var ttBeforePromo = Math.round(total / 0.9);
      byId('price-old').textContent = ttBeforePromo.toLocaleString('fr-FR') + ' €';
      byId('price-old').style.display = 'inline';
    } else {
      byId('price-old').style.display = 'none';
    }
    var dl = discLabel();
    byId('disc-tag').style.display = dl ? 'inline-block' : 'none';
    byId('disc-tag').textContent = dl;

    if (nPann > 1) {
      var effUnit = subtotal / nPann;
      byId('price-unit').textContent = 'soit ' + effUnit.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' € / panneau';
    } else {
      byId('price-unit').textContent = '';
    }
    byId('price-sub').textContent = 'Prix HT · hors frais de port';
    var spv = byId('sticky-price-v'); if (spv) spv.textContent = byId('price-v').textContent;
    var spu = byId('sticky-price-unit'); if (spu) spu.textContent = byId('price-unit').textContent;

    // Détails
    byId('pd-fmt').textContent = fl;
    byId('pd-mat').textContent = state.matN;
    byId('pd-qty').textContent = nPann + (nPann > 1 ? ' panneaux' : ' panneau');

    // Option fixation : œillets (PP) vs perçage (alu rigide)
    var isAlu = state.mat === 'alu';
    var fixTitle = isAlu ? 'Perçage (4 trous Ø6 mm)' : 'Œillets de fixation';
    var fixDesc = isAlu
      ? '4 trous Ø6 mm percés aux angles · pour fixation vis, boulons ou colliers sur support rigide'
      : '4 œillets métalliques posés aux 4 coins · pour fixation par sandow, fil de fer ou colliers';
    var fot = byId('fix-opt-title'); if (fot) fot.textContent = fixTitle;
    var fod = byId('fix-opt-desc'); if (fod) fod.textContent = fixDesc;
    var fpk = byId('pd-oeillets-k'); if (fpk) fpk.textContent = isAlu ? 'Perçage' : 'Œillets';
    if (state.oeillets) {
      byId('pd-oeillets-k').style.display = '';
      byId('pd-oeillets').style.display = '';
      byId('pd-oeillets').textContent = '+' + (2 * nPann) + ' € (' + nPann + ' × 4)';
    } else {
      byId('pd-oeillets-k').style.display = 'none';
      byId('pd-oeillets').style.display = 'none';
    }

    if (state.crea) {
      byId('pd-crea-k').style.display = '';
      byId('pd-crea').style.display = '';
      byId('pd-crea').textContent = '+50 €';
    } else {
      byId('pd-crea-k').style.display = 'none';
      byId('pd-crea').style.display = 'none';
    }
    var creaDet = byId('crea-details'); if (creaDet) creaDet.style.display = state.crea ? 'block' : 'none';

    // Recto-verso (agent)
    var rvk = byId('pd-rv-k'), rvv = byId('pd-rv');
    if (rvk && rvv) {
      if (rvActive()) { rvk.style.display = ''; rvv.style.display = ''; rvv.textContent = 'Oui'; }
      else { rvk.style.display = 'none'; rvv.style.display = 'none'; }
    }

    if (state.promoApplied) {
      byId('pd-promo-k').style.display = '';
      byId('pd-promo').style.display = '';
      byId('pd-promo').textContent = '-10%';
    } else {
      byId('pd-promo-k').style.display = 'none';
      byId('pd-promo').style.display = 'none';
    }
  }

  /* Compteurs live de la colonne de gauche : répartition agent + quantités unité.
     (L'ancienne carte « Récapitulatif » de droite a été supprimée — résumé désormais
     uniquement dans la carte prix.) */
  function renderCounters() {
    // Agent : total de la répartition par statut
    if (state.cat === 'agent') {
      var tot = state.qte_av + state.qte_al + state.qte_vd;
      var stt = byId('statut-tot');
      if (stt) {
        if (tot === state.lot) {
          stt.className = 'statut-tot ok';
          stt.textContent = 'Total : ' + tot + ' / ' + state.lot + ' panneaux ✓';
        } else {
          stt.className = 'statut-tot err';
          stt.textContent = 'Total : ' + tot + ' / ' + state.lot + ' panneaux — répartition à ajuster';
        }
      }
    }
    ['qty-av', 'qty-al', 'qty-vd'].forEach(function (id) {
      var k = id.split('-')[1];
      var v = { av: state.qte_av, al: state.qte_al, vd: state.qte_vd }[k];
      var e = byId(id);
      if (e) e.textContent = v;
    });
    // Compteurs cartQty (permis unité, habillage unité, immo, lots Pub)
    ['cartqty-permis', 'cartqty-hab', 'cartqty-immo', 'cartqty-pub'].forEach(function (id) {
      var e = byId(id);
      if (e) e.textContent = state.cartQty;
    });
    // Multi-lots Pub : stepper visible seulement sur lot 10 (×1-4) et lot 100 (×1-5) ; caché sur lot 50
    var pubRow = byId('pub-qty-row');
    if (pubRow) {
      var pubStepper = state.cat === 'pub' && (state.lot === 10 || state.lot === 100);
      pubRow.style.display = pubStepper ? '' : 'none';
      var detail = byId('pub-qty-detail');
      if (pubStepper && detail) {
        var totP = state.lot * state.cartQty;
        var perPanel = state.lot ? getVariantPrice() / state.lot : 0;
        var hint = '';
        if (state.lot === 10 && state.cartQty >= 4) hint = ' · besoin de plus ? prenez le lot de 50';
        else if (state.lot === 100 && state.cartQty >= 5) hint = ' · au-delà de 500, c’est un devis';
        detail.textContent = '= ' + totP + ' panneaux · ' + perPanel.toFixed(2).replace('.', ',') + ' €/panneau' + hint;
      }
    }
    // Ligne quantité permis unité
    var permisUnitQty = byId('permis-unit-qty');
    if (permisUnitQty) permisUnitQty.classList.toggle('on', state.cat === 'permis' && state.lot === 1);
  }

  function renderPort() {
    var pb = byId('port-box');
    pb.className = 'port-box';
    if (state.cat === 'habillage' && state.habType === 'immo3x2') {
      pb.innerHTML = '<strong>Transport spécifique grand format</strong> · Devis transport au panier';
    } else {
      pb.innerHTML = '<strong>Frais de port calculés au panier</strong> · Livraison J+5 ouvrés';
    }
  }

  function renderButton() {
    var btn = byId('btn-cart'), sc = byId('sticky-cart');
    if (isDevis()) {
      btn.style.display = 'none';
      if (sc) sc.style.display = 'none';
    } else {
      btn.style.display = 'block';
      btn.textContent = 'Ajouter au panier →';
      if (sc) sc.style.display = '';
    }
  }

  /* Toggle recto-verso : visible en agent, grisé si indisponible. */
  function renderRv() {
    // Auto-désactive le R/V si la config courante ne le permet plus.
    if (state.rv && !rvAvailable()) state.rv = false;

    var card = byId('rv-card');
    if (!card) return;
    card.style.display = state.cat === 'agent' ? '' : 'none';
    if (state.cat !== 'agent') return;

    var available = rvAvailable();
    var note = byId('rv-note');

    document.querySelectorAll('#rv-pills .pill').forEach(function (p) {
      var isRvPill = p.dataset.rv === '1';
      p.classList.toggle('on', isRvPill === state.rv);
      // La pastille « Recto-verso » est grisée quand l'option n'est pas disponible.
      p.classList.toggle('off', isRvPill && !available);
    });

    if (!note) return;
    if (!available) {
      note.textContent = rvReason();
    } else {
      var st = rvStatuses();
      note.textContent = state.rv
        ? 'Verso imprimé automatiquement : ' + st.verso + ' (recto ' + st.recto + ')'
        : 'Un seul panneau pour tout le cycle : recto ' + st.recto + ' / verso ' + st.verso;
    }
  }

  /* ═══════════════════════════════════════════════════════════
     10. MUTATIONS D'ÉTAT (déclenchées par la délégation)
     ═══════════════════════════════════════════════════════════ */

  /* Active une pastille `.pill` dans un groupe (et désactive les autres). */
  function setActivePill(groupId, el) {
    byId(groupId).querySelectorAll('.pill').forEach(function (p) { p.classList.remove('on'); });
    el.classList.add('on');
  }

  function pdcSwitch(c) {
    state.cat = c;
    ['pub', 'permis', 'agent', 'habillage'].forEach(function (x) {
      var el = byId('sec-' + x);
      if (el) el.style.display = x === c ? '' : 'none';
    });
    document.querySelectorAll('.pdc-tab').forEach(function (t) { t.classList.toggle('on', t.dataset.c === c); });
    updateExamplesVisibility();

    // Hero adaptatif : titre + sous-titre alignés sur l'intention de la catégorie (intent-match → meilleure conversion + Quality Score sur l'ads).
    var HERO = {
      pub:       { h: 'Configurez votre panneau,<br><em>commandez en 2 minutes.</em>', sub: 'Aperçu en temps réel · prix instantané · livraison J+5.' },
      permis:    { h: 'Votre panneau de permis de construire,<br><em>conforme et livré en 2 minutes.</em>', sub: 'Mentions réglementaires R. 424-15 · fabriqué en France · livraison J+5.' },
      agent:     { h: 'Votre panneau immobilier,<br><em>commandé en 2 minutes.</em>', sub: 'Vente ou location, recto-verso · prix instantané · livraison J+5.' },
      habillage: { h: 'Votre habillage grand format,<br><em>configuré en 2 minutes.</em>', sub: 'Sur mesure · aperçu en temps réel · livraison J+5.' }
    };
    var heroH = byId('pdc-hero-h'), heroSub = byId('pdc-hero-sub'), hero = HERO[c] || HERO.pub;
    if (heroH) heroH.innerHTML = hero.h;
    if (heroSub) heroSub.textContent = hero.sub;

    if (c === 'pub') {
      state.fw = 60; state.fh = 40; state.lot = 10; state.cartQty = 1; state.matN = 'PP alvéolaire 3,5 mm'; state.mat = 'pp'; state.ori = 'paysage'; state.mode = 'file';
      document.querySelectorAll('#pub-packs .pack-pill').forEach(function (p) { p.classList.toggle('on', parseInt(p.dataset.q) === 10); });
      document.querySelectorAll('#fmt-pills .pill').forEach(function (p) { p.classList.toggle('on', parseInt(p.dataset.w) === 60 && parseInt(p.dataset.h) === 40); });
      document.querySelectorAll('#ori-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.value === 'paysage'); });
      document.querySelectorAll('#mat-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
      document.querySelectorAll('#mode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === 'file'); });
      byId('mode-file').style.display = '';
      byId('mode-later').style.display = 'none';
      byId('mode-guide').style.display = 'none';
    } else if (c === 'permis') {
      state.fw = 80; state.fh = 120; state.lot = 1; state.cartQty = 1; state.matN = 'PP alvéolaire 3,5 mm'; state.mat = 'pp';
      document.querySelectorAll('#pmat-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
      state.pmMode = 'file';
      document.querySelectorAll('#pmode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === 'file'); });
      byId('pm-guide').style.display = 'none';
      byId('pm-file').style.display = '';
      byId('pm-later').style.display = 'none';
    } else if (c === 'agent') {
      state.fw = 40; state.fh = 60; state.lot = 10; state.cartQty = 1; state.qte_av = 10; state.qte_al = 0; state.qte_vd = 0; state.matN = 'PP alvéolaire 3,5 mm'; state.mat = 'pp'; state.rv = false; state.aOri = 'paysage';
      document.querySelectorAll('#agent-packs .pack-pill').forEach(function (p) { p.classList.toggle('on', parseInt(p.dataset.q) === 10); });
      document.querySelectorAll('#afmt-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
      document.querySelectorAll('#amat-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
      document.querySelectorAll('#aori-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.value === 'paysage'); });
      // Mode fichier par défaut + nettoyage des uploads recto/verso
      state.aMode = 'file';
      state.aFile = { url: '', file: null, name: '' };
      state.aFileVerso = { url: '', file: null, name: '' };
      ['aFile', 'aFileVerso'].forEach(function (k) {
        var t = byId(k + '-thumb'); if (t) t.style.display = 'none';
        var z = byId(k + '-zone'); if (z) z.style.display = '';
        var q = byId(k + '-qb'); if (q) q.style.display = 'none';
      });
      document.querySelectorAll('#amode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === 'file'); });
      byId('amode-file').style.display = '';
      byId('amode-later').style.display = 'none';
      byId('amode-guide').style.display = 'none';
    } else if (c === 'habillage') {
      state.habType = 'habillage'; state.lot = 1; state.cartQty = 1; state.matN = 'Alu composite 3 mm'; state.mat = 'alu';
      document.querySelectorAll('#hmat-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
      showHabType();
    }
    render();
  }

  function showHabType() {
    ['habillage', 'immo3x2', 'devis'].forEach(function (t) {
      var el = byId('hab-' + t);
      if (el) el.style.display = t === state.habType ? '' : 'none';
    });
    document.querySelectorAll('#hab-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.h === state.habType); });
    state.habLater = false;
    document.querySelectorAll('#hmode-pills .pill, #imode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === 'file'); });
    ['habf', 'immof'].forEach(function (k) {
      var up = byId(k + '-up'); if (up) up.style.display = '';
      var lt = byId(k + '-later'); if (lt) lt.style.display = 'none';
    });
  }

  function setHabType(el) {
    state.habType = el.dataset.h;
    if (state.habType === 'immo3x2') {
      state.matN = 'PP alvéolaire 5 mm'; state.mat = 'pp'; state.lot = null; state.cartQty = 1;
      document.querySelectorAll('#imat-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
    } else if (state.habType === 'habillage') {
      state.matN = 'Alu composite 3 mm'; state.mat = 'alu'; state.lot = 1; state.cartQty = 1;
      document.querySelectorAll('#hmat-pills .pill').forEach(function (p, i) { p.classList.toggle('on', i === 0); });
    }
    showHabType();
    render();
  }

  function setHabMode(m) {
    state.habLater = (m === 'later');
    document.querySelectorAll('#hmode-pills .pill, #imode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === m); });
    ['habf', 'immof'].forEach(function (k) {
      var up = byId(k + '-up'); if (up) up.style.display = state.habLater ? 'none' : '';
      var lt = byId(k + '-later'); if (lt) lt.style.display = state.habLater ? '' : 'none';
    });
    if (state.habLater) {
      state.habf = { url: '', file: null, name: '' };
      state.immof = { url: '', file: null, name: '' };
    }
    render();
  }

  /* Format (pub : groupe fmt-pills ; agent : groupe afmt-pills). */
  function setFormat(el, groupId) {
    setActivePill(groupId, el);
    state.fw = parseInt(el.dataset.w);
    state.fh = parseInt(el.dataset.h);
    render();
  }

  function setMat(el, groupId) {
    setActivePill(groupId, el);
    state.mat = el.dataset.m;
    state.matN = el.dataset.n;
    render();
  }

  function setMask(m) {
    state.mask = m;
    document.querySelectorAll('.mask-card').forEach(function (c) { c.classList.toggle('on', c.dataset.mask === m); });
    render();
  }

  /* Pastille `.pill` qui pilote un champ d'état (orientation pub/immo). */
  function setPillField(el, groupId, field, value) {
    setActivePill(groupId, el);
    setStatePath(field, value);
    render();
  }

  /* Nuancier de couleur (`.sw`) pilotant un champ d'état. */
  function setSwatch(el, groupId, field, value) {
    byId(groupId).querySelectorAll('.sw').forEach(function (s) { s.classList.remove('on'); });
    el.classList.add('on');
    setStatePath(field, value);
    render();
  }

  function setMode(m) {
    state.mode = m;
    document.querySelectorAll('#mode-pills [data-mode]').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === m); });
    byId('mode-guide').style.display = m === 'guide' ? '' : 'none';
    byId('mode-file').style.display = m === 'file' ? '' : 'none';
    byId('mode-later').style.display = m === 'later' ? '' : 'none';
    byId('mode-ia').style.display = m === 'ia' ? '' : 'none';
    if (m === 'ia') {
      var mia = byId('mode-ia');
      if (mia && mia.scrollIntoView) setTimeout(function () { mia.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      iaSyncSwatches();
    }
    if (m === 'ia' && state.ori !== 'paysage') {
      // Les designs IA sont composés au format paysage 3:2 (60×40 et 120×80)
      state.ori = 'paysage';
      document.querySelectorAll('#ori-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.value === 'paysage'); });
    }
    if (m !== 'file') state.pubf = { url: '', file: null, name: '' };
    // mode ia : on CONSERVE la génération en cours (state.ia) si l'utilisateur navigue
    render();
  }

  function setAgentMode(m) {
    state.aMode = m;
    document.querySelectorAll('#amode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === m); });
    byId('amode-file').style.display = m === 'file' ? '' : 'none';
    byId('amode-later').style.display = m === 'later' ? '' : 'none';
    byId('amode-guide').style.display = m === 'guide' ? '' : 'none';
    if (m !== 'file') {
      state.aFile = { url: '', file: null, name: '' };
      state.aFileVerso = { url: '', file: null, name: '' };
    }
    if (m !== 'guide') {
      // Répartition masquée hors simulateur → on la remet homogène pour garder le R/V dispo.
      state.qte_av = state.lot; state.qte_al = 0; state.qte_vd = 0;
    }
    render();
  }

  function setPermisMode(m) {
    state.pmMode = m;
    document.querySelectorAll('#pmode-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.mode === m); });
    byId('pm-guide').style.display = m === 'guide' ? '' : 'none';
    byId('pm-file').style.display = m === 'file' ? '' : 'none';
    byId('pm-later').style.display = m === 'later' ? '' : 'none';
    if (m !== 'file') state.pmf = { url: '', file: null, name: '' };
    render();
  }

  /* Variante d'autorisation : bascule les lignes du formulaire + libellé du n° + aperçu. */
  function setPermisType(t, el) {
    if (!PM_TYPES[t]) t = 'pc';
    state.pm.type = t;
    document.querySelectorAll('#pmtype-pills .pill').forEach(function (p) { p.classList.toggle('on', p.dataset.value === t); });
    var def = PM_TYPES[t];
    var rows = { 'pmrow-surf': def.surf, 'pmrow-haut': def.haut, 'pmrow-demol': def.demol, 'pmrow-lots': def.lots, 'pmrow-empl': def.lots };
    Object.keys(rows).forEach(function (id) { var r = byId(id); if (r) r.style.display = rows[id] ? '' : 'none'; });
    var lbl = byId('pmlbl-num'), inp = byId('pminp-num');
    if (lbl) lbl.textContent = def.numLbl;
    if (inp) inp.placeholder = def.numPh;
    render();
  }

  function setPack(el, q) {
    var parent = el.closest('.pack-pills');
    if (parent) parent.querySelectorAll('.pack-pill').forEach(function (p) { p.classList.remove('on'); });
    el.classList.add('on');
    state.lot = q;
    if (q !== 1) state.cartQty = 1;
    if (state.cat === 'agent') { state.qte_av = q; state.qte_al = 0; state.qte_vd = 0; }
    render();
  }

  /* Plafond de multiplication des lots — Pub : 10 → ×4, 50 → pas de multi, 100 → ×5 (au-delà = devis). */
  function maxLots() {
    if (state.cat === 'pub') {
      if (state.lot === 10) return 4;
      if (state.lot === 100) return 5;
      return 1; // lot de 50 : pas de sélection de quantité
    }
    return 20; // permis / habillage / immo : compteur à l'unité
  }

  function chgCartQty(d) {
    state.cartQty = Math.max(1, Math.min(maxLots(), state.cartQty + d));
    render();
  }

  function chgStatut(k, d) {
    var cur = { av: state.qte_av, al: state.qte_al, vd: state.qte_vd }[k];
    var tot = state.qte_av + state.qte_al + state.qte_vd;
    if (d > 0 && tot >= state.lot) return;
    if (d < 0 && cur === 0) return;
    if (k === 'av') state.qte_av = Math.max(0, state.qte_av + d);
    if (k === 'al') state.qte_al = Math.max(0, state.qte_al + d);
    if (k === 'vd') state.qte_vd = Math.max(0, state.qte_vd + d);
    render();
  }

  function setRv(on) {
    if (on && !rvAvailable()) return; // ignore le clic si l'option est grisée
    state.rv = on;
    render();
  }

  /* Formatage auto jj/mm/aaaa des dates permis. */
  function autoDate(el, key) {
    var v = el.value.replace(/\D/g, '').slice(0, 8);
    if (v.length > 4) v = v.slice(0, 2) + '/' + v.slice(2, 4) + '/' + v.slice(4);
    else if (v.length > 2) v = v.slice(0, 2) + '/' + v.slice(2);
    el.value = v;
    setStatePath(key, v);
    render();
  }

  /* ═══════════════════════════════════════════════════════════
     11. FICHIERS (import simple + multi-fichiers création graphique)
     ═══════════════════════════════════════════════════════════ */
  function handleFile(inp, key) {
    if (!inp.files || !inp.files[0]) return;
    var f = inp.files[0];
    // Garde-fou taille : Cloudinary refuse > 10 Mo → on bascule sur « J'envoie plus tard » plutôt qu'un échec silencieux au panier.
    if (f.size > 10 * 1024 * 1024) {
      inp.value = '';
      var toLater = { pubf: setMode, pmf: setPermisMode, habf: setHabMode, aFile: setAgentMode, aFileVerso: setAgentMode };
      alert('Votre fichier fait ' + (f.size / 1024 / 1024).toFixed(1) + ' Mo (maximum 10 Mo en ligne).\n\nPas de souci : on passe sur « J\'envoie plus tard » — finalisez votre commande, on récupère votre fichier par email, sans limite de taille.');
      if (toLater[key]) toLater[key]('later');
      return;
    }
    state[key] = { url: '', file: f, name: f.name };
    var zone = byId(key + '-zone'); if (zone) zone.style.display = 'none';
    var t = byId(key + '-thumb');
    if (!t) return;
    t.style.display = 'flex';
    var img = byId(key + '-thumb-img');
    var n = byId(key + '-thumb-name'); if (n) n.textContent = f.name;
    var m = byId(key + '-thumb-meta'); if (m) m.textContent = (f.size / 1024 / 1024).toFixed(1) + ' Mo · ' + (f.type.split('/').pop() || '').toUpperCase();

    if (f.type.startsWith('image/')) {
      var reader = new FileReader();
      reader.onload = function (e) {
        state[key].url = e.target.result;
        if (img) img.src = e.target.result;
        var im = new Image();
        im.onload = function () {
          state[key].ratio = im.width / im.height; // pour adapter le layout SVG
          var pw, ph;
          if (key === 'pubf') { var lP = Math.max(state.fw, state.fh), sP = Math.min(state.fw, state.fh); pw = state.ori === 'paysage' ? lP : sP; ph = state.ori === 'paysage' ? sP : lP; }
          else if (key === 'pmf') { pw = 80; ph = 120; }
          else if (key === 'habf') { pw = 180; ph = 100; }
          else if (key === 'immof') { pw = state.immoOri === 'paysage' ? 300 : 200; ph = state.immoOri === 'paysage' ? 200 : 300; }
          else if (key === 'aFile' || key === 'aFileVerso') { var lA = Math.max(state.fw, state.fh), sA = Math.min(state.fw, state.fh); pw = state.aOri === 'portrait' ? sA : lA; ph = state.aOri === 'portrait' ? lA : sA; }
          if (pw && ph) showDPI(key, im.width, im.height, pw, ph);
          render();
        };
        im.src = e.target.result;
        render();
      };
      reader.readAsDataURL(f);
    } else {
      if (img) img.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><rect width="48" height="48" rx="4" fill="%23f4f3f1"/><text x="24" y="30" text-anchor="middle" font-size="16" fill="%23999">📄</text></svg>';
      render();
    }
  }

  function rmFile(key) {
    state[key] = { url: '', file: null, name: '' };
    var t = byId(key + '-thumb'); if (t) t.style.display = 'none';
    var z = byId(key + '-zone'); if (z) z.style.display = '';
    var q = byId(key + '-qb'); if (q) q.style.display = 'none';
    render();
  }

  function handleCreaFiles(inp) {
    if (!inp.files || !inp.files.length) return;
    for (var i = 0; i < inp.files.length; i++) state.creaFiles.push(inp.files[i]);
    renderCreaList();
  }

  function rmCreaFile(idx) {
    state.creaFiles.splice(idx, 1);
    renderCreaList();
  }

  function renderCreaList() {
    var list = byId('creafiles-list');
    if (!list) return;
    if (!state.creaFiles.length) { list.innerHTML = ''; return; }
    var h = '';
    state.creaFiles.forEach(function (f, i) {
      h += '<div class="up-thumb" style="margin-top:6px"><div class="up-thumb-info"><div class="up-thumb-name">' + clip(f.name, 32) + '</div><div class="up-thumb-meta">' + (f.size / 1024 / 1024).toFixed(1) + ' Mo</div></div><div class="up-remove" data-action="rm-crea" data-idx="' + i + '">Retirer</div></div>';
    });
    list.innerHTML = h;
  }

  /* ═══════════════════════════════════════════════════════════
     12. PANIER (validation → upload Cloudinary → /cart/add.js)
     ═══════════════════════════════════════════════════════════ */
  function addCart() {
    var btn = byId('btn-cart'), prog = byId('up-prog'), bar = byId('up-bar'), stat = byId('up-stat');

    if (isDevis()) { window.location = '/pages/contact?sujet=Devis grand format'; return; }

    if (!validate()) {
      byId('val-warn').style.display = '';
      if (state.cat === 'agent' && (state.qte_av + state.qte_al + state.qte_vd) !== state.lot) toast('La répartition par statut doit égaler votre lot');
      else toast('Informations requises manquantes');
      return;
    }

    var vid = getVID();
    if (!vid) { toast('Variante Shopify introuvable — contactez-nous'); return; }

    batchId = newBatchId(); // jeton unique partagé par tous les fichiers de CETTE commande
    btn.disabled = true;
    btn.textContent = 'Préparation…';
    var price = calcPrice();
    var total = price.total, subtotal = price.subtotal, qtyForPrice = price.qtyForPrice;

    var props = buildCartProperties(subtotal);
    var files = collectFiles();

    uploadFilesThenAdd(files, props, vid, qtyForPrice, btn, prog, bar, stat);
  }

  /* Construit les properties (visibles + cachées `_`) de la ligne panier. */
  function buildCartProperties(subtotal) {
    var props = {
      // Visibles client
      'Format': fmtLabel(),
      'Matière': state.matN,
      'Quantité': totalPanneaux() + (totalPanneaux() > 1 ? ' panneaux' : ' panneau'),
      // Cachées (préfixe _) — visibles uniquement en admin
      '_Catégorie': catLabel(),
      '_Sous-total HT': subtotal + ' €'
    };

    if (state.cat === 'pub') {
      props['Masque'] = state.mask.charAt(0).toUpperCase() + state.mask.slice(1);
      props['_Orientation'] = state.ori;
      props['_Mode'] = state.mode === 'guide' ? 'Guidé' : state.mode === 'later' ? 'Fichier par mail' : state.mode === 'ia' ? 'Design IA' : 'Fichier';
      if (state.mode === 'later') props['_Fichier'] = '📧 À RECEVOIR — contacter le client par mail';
      if (state.mode === 'ia' && state.ia.chosen >= 0) {
        var iap = state.ia.props[state.ia.chosen];
        props['Design'] = 'Création par IA offerte';
        props['_DesignIA'] = state.ia.id + ' · proposition ' + (state.ia.chosen + 1);
        props['_DesignIA détail'] = iap.layout + ' / ' + iap.palette;
        if (state.iaNom) props['_Nom'] = state.iaNom;
        if (state.iaTel) props['_Tél'] = state.iaTel;
        if (state.iaEmail) props['_Email'] = state.iaEmail;
      }
      if (state.nom) props['_Nom'] = state.nom;
      if (state.tel) props['_Tél'] = state.tel;
      if (state.mail) props['_Email'] = state.mail;
      if (state.web) props['_Web'] = state.web;
      if (state.activites) props['_Activités'] = state.activites.split('\n').filter(Boolean).join(' / ');
      if (state.slogan) props['_Slogan'] = state.slogan;
      props['_Fond'] = state.bgCol;
      props['_Texte'] = state.txtCol;
    }
    if (state.cat === 'permis') {
      props['_Mode'] = state.pmMode === 'guide' ? 'Saisie' : (state.pmMode === 'later' ? 'Fichier par mail' : 'Fichier');
      if (state.pmMode === 'later') props['_Fichier'] = '📧 À RECEVOIR — contacter le client par mail';
      props['_Bandeau'] = state.pmBanCol;
      var pm = state.pm;
      if (state.pmMode === 'guide') props['Type d\'autorisation'] = pmType().titre;
      if (pm.nature) props['_Nature du projet'] = pm.nature;
      if (pm.lots) props['_Nombre de lots'] = pm.lots;
      if (pm.nom) props['_Bénéficiaire'] = pm.nom + (pm.rs ? ' — ' + pm.rs : '');
      if (pm.num) props['_N° permis'] = pm.num;
      if (pm.surf) props['_Surface'] = pm.surf + ' m²';
      if (pm.haut) props['_Hauteur'] = pm.haut + ' m';
      if (pm.demol) props['_Surface à démolir'] = pm.demol + ' m²';
      if (pm.archi) props['_Architecte'] = pm.archi;
      if (pm.mairie) props['_Mairie'] = pm.mairie;
      if (pm.ddate) props['_Délivrance'] = pm.ddate;
      if (pm.terrain) props['_Terrain'] = pm.terrain + ' m²';
    }
    if (state.cat === 'agent') {
      props['Répartition'] = state.qte_av + ' À VENDRE · ' + state.qte_al + ' À LOUER · ' + state.qte_vd + ' VENDU';
      props['Orientation'] = state.aOri === 'portrait' ? 'Portrait' : 'Paysage';
      props['_Mode'] = state.aMode === 'later' ? 'Fichier par mail' : (state.aMode === 'file' ? 'Fichier' : 'Simulateur');
      if (state.aMode === 'later') props['_Fichier'] = '📧 À RECEVOIR — contacter le client par mail';
      if (state.aMode === 'guide') {
        if (state.agency.nom) props['_Agence'] = state.agency.nom;
        if (state.agency.tel) props['_Tél agence'] = state.agency.tel;
        if (state.agency.mail) props['_Email agence'] = state.agency.mail;
        if (state.agency.web) props['_Web agence'] = state.agency.web;
        props['_Couleur fond'] = state.aBgCol;
        props['_Couleur texte'] = state.aTxtCol;
      }
      if (rvActive()) {
        var rvSt = rvStatuses();
        props['Recto-verso'] = 'Oui — recto ' + rvSt.recto + ' / verso ' + rvSt.verso;
        props['_Verso'] = rvSt.verso;
      }
    }
    if (state.cat === 'habillage') {
      props['Type'] = state.habType === 'habillage' ? 'Module 1,8 × 1 m' : 'Promo 3 × 2 m';
      if (state.habType === 'immo3x2') props['_Orientation'] = state.immoOri;
      if (state.habLater) { props['_Mode'] = 'Fichier par mail'; props['_Fichier'] = '📧 À RECEVOIR — contacter le client par mail'; }
    }
    if (state.promoApplied) props['_Code promo'] = state.promo + ' (-10% à appliquer)';

    // Fixation (visible client)
    if (state.oeillets) {
      var fixLabel = state.mat === 'alu' ? 'Perçage (4 trous Ø6 mm)' : 'Œillets de fixation';
      props[fixLabel] = 'Oui — ' + totalPanneaux() + ' × 4 (+' + (2 * totalPanneaux()) + ' € HT)';
    }
    // Création graphique
    if (state.crea) {
      props['Création graphique'] = 'Oui — par notre équipe (+50 € HT)';
      if (state.creaBrief && state.creaBrief.trim()) props['_Brief créa'] = state.creaBrief.trim();
      props['_Éléments créa fournis'] = state.creaFiles.length + ' fichier(s)';
    }
    /* Fichiers d'une création reprise (déjà sur Cloudinary, plus de File local en mémoire) */
    SAVE_FILES.forEach(function (s) {
      var o = state[s.path];
      if (o && !o.file && o.cloud && (s.path !== 'aFileVerso' || rvActive())) props[s.key] = o.cloud;
    });
    return props;
  }

  /* Liste des fichiers à uploader : maquette composée (atelier) + sources (client). */
  function collectFiles() {
    var files = [];
    // Maquette SVG composée : seulement en mode simulateur/guidé (sinon = fichier client).
    var svgFile = isGuidedMode() ? getMaquetteSVG() : null;
    if (svgFile) files.push({ f: svgFile, t: 'maquette', k: '_Maquette à imprimer', sub: 'maquettes' });
    if (state.logo.file) files.push({ f: state.logo.file, t: 'logo', k: '_Logo source', sub: 'sources' });
    if (state.pubf.file) files.push({ f: state.pubf.file, t: 'fichier-pub', k: '_Fichier source', sub: 'sources' });
    if (state.pmlogo.file) files.push({ f: state.pmlogo.file, t: 'logo-permis', k: '_Logo permis source', sub: 'sources' });
    if (state.pmf.file) files.push({ f: state.pmf.file, t: 'fichier-permis', k: '_Fichier permis source', sub: 'sources' });
    if (state.alogo.file) files.push({ f: state.alogo.file, t: 'logo-agence', k: '_Logo agence source', sub: 'sources' });
    if (state.aFile.file) files.push({ f: state.aFile.file, t: 'agent-recto', k: '_Fichier recto', sub: 'sources' });
    if (rvActive() && state.aFileVerso.file) files.push({ f: state.aFileVerso.file, t: 'agent-verso', k: '_Fichier verso', sub: 'sources' });
    if (state.habf.file) files.push({ f: state.habf.file, t: 'visuel-habillage', k: '_Visuel source', sub: 'sources' });
    if (state.immof.file) files.push({ f: state.immof.file, t: 'visuel-grand-format', k: '_Visuel grand format source', sub: 'sources' });
    if (state.crea && state.creaFiles.length) {
      state.creaFiles.forEach(function (f, i) { files.push({ f: f, t: 'crea-element-' + (i + 1), k: '_Élément créa ' + (i + 1), sub: 'sources' }); });
    }
    return files;
  }

  /* Upload séquentiel des fichiers (barre de progression) puis ajout au panier. */
  /* Signale l'ajout au panier à GA4 / Google Ads. Le fetch custom /cart/add.js
     ne déclenche pas le Web Pixel Shopify → on émet l'événement nous-mêmes.
     Tout en try/catch : ne doit JAMAIS bloquer l'ajout au panier. */
  function trackAddToCart(vid, qty) {
    try {
      var p = calcPrice();
      var val = p.subtotal;
      var item = {
        item_id: String(vid),
        item_name: catLabel() + ' ' + fmtLabel(),
        quantity: qty,
        price: (qty ? +(val / qty).toFixed(2) : val)
      };
      if (window.gtag) gtag('event', 'add_to_cart', { currency: 'EUR', value: val, items: [item] });
      if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: 'EUR', value: val, items: [item] } });
      if (state.cat === 'pub' && state.mode === 'ia') designerEvt('order-click');
    } catch (e) { console.error('trackAddToCart', e); }
  }

  /* ---- Recadrage auto au ratio du format ----
     Le fichier client EST le fichier d'impression : on le recadre (centré, pleine
     résolution) au ratio exact du format commandé avant l'envoi Cloudinary.
     Permis exclu (zone visuel + bandeau composés à l'atelier). Échec = fichier original. */
  function printDims(t) {
    var l = Math.max(state.fw, state.fh), s = Math.min(state.fw, state.fh);
    if (t === 'fichier-pub') return state.ori === 'portrait' ? [s, l] : [l, s];
    if (t === 'agent-recto' || t === 'agent-verso') return state.aOri === 'portrait' ? [s, l] : [l, s];
    if (t === 'visuel-habillage') return [180, 100];
    if (t === 'visuel-grand-format') return state.immoOri === 'paysage' ? [300, 200] : [200, 300];
    return null;
  }
  function cropToRatio(file, pw, ph) {
    return new Promise(function (resolve) {
      if (!file || !pw || !ph || !/^image\/(jpeg|png|webp)$/i.test(file.type)) return resolve(file);
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var W = img.naturalWidth, H = img.naturalHeight, target = pw / ph;
        if (!W || !H || W * H > 24000000) return resolve(file); /* limite canvas mobile */
        if (Math.abs(W / H - target) / target < 0.02) return resolve(file); /* déjà au bon ratio */
        var cw = W, ch = H;
        if (W / H > target) cw = Math.round(H * target); else ch = Math.round(W / target);
        try {
          var cv = document.createElement('canvas');
          cv.width = cw; cv.height = ch;
          cv.getContext('2d').drawImage(img, Math.round((W - cw) / 2), Math.round((H - ch) / 2), cw, ch, 0, 0, cw, ch);
          cv.toBlob(function (b) {
            resolve(b ? new File([b], file.name, { type: b.type }) : file);
          }, /png$/i.test(file.type) ? 'image/png' : 'image/jpeg', 0.92);
        } catch (e) { resolve(file); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  function uploadFilesThenAdd(files, props, vid, qtyForPrice, btn, prog, bar, stat) {
    var chain = Promise.resolve();
    if (files.length) {
      prog.classList.add('on');
      bar.style.width = '0%';
      chain = chain.then(function () {
        var seq = Promise.resolve();
        files.forEach(function (entry, i) {
          seq = seq.then(function () {
            stat.textContent = 'Envoi ' + (i + 1) + '/' + files.length + ' : ' + entry.f.name;
            bar.style.width = Math.round((i / files.length) * 80) + '%';
            btn.textContent = 'Envoi…';
            var pd = printDims(entry.t);
            var prep = pd ? cropToRatio(entry.f, pd[0], pd[1]) : Promise.resolve(entry.f);
            return prep.then(function (ff) {
              if (ff !== entry.f) props['_Recadrage auto'] = (props['_Recadrage auto'] ? props['_Recadrage auto'] + ' · ' : '') + entry.t + ' → ' + pd[0] + '×' + pd[1];
              return upload(ff, entry.t, entry.sub).then(function (url) { if (url) props[entry.k] = url; });
            });
          });
        });
        return seq.then(function () {
          bar.style.width = '85%';
          stat.textContent = '✓ Fichiers envoyés';
        });
      }).catch(function (e) {
        console.error(e);
        toast('Erreur upload');
        props['_Note'] = 'Upload échoué';
      });
    }

    chain.then(function () {
      btn.textContent = 'Ajout panier…';
      bar.style.width = '95%';
      var items = [{ id: vid, quantity: qtyForPrice, properties: props }];
      if (state.crea && CREA_VID) items.push({ id: CREA_VID, quantity: 1, properties: { 'Pour': catLabel() + ' ' + fmtLabel() } });
      if (state.oeillets) {
        var fixVid = (state.mat === 'alu') ? PERC_VID : OEIL_VID;
        if (fixVid) items.push({ id: fixVid, quantity: totalPanneaux(), properties: { 'Pour': catLabel() + ' ' + fmtLabel() } });
      }

      var addSeq = Promise.resolve();
      items.forEach(function (it) {
        addSeq = addSeq.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(it) })
            .then(function (r) {
              if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || 'Erreur'); });
            });
        });
      });

      return addSeq.then(function () {
        bar.style.width = '100%';
        stat.textContent = '✓ Ajouté';
        btn.textContent = '✓ Redirection…';
        toast('Ajouté au panier ✓');
        trackAddToCart(vid, qtyForPrice);
        setTimeout(function () { window.location = '/cart'; }, 1200);
      });
    }).catch(function (e) {
      console.error(e);
      toast('Erreur : ' + e.message);
      btn.disabled = false;
      btn.textContent = 'Ajouter au panier →';
      prog.classList.remove('on');
    });
  }

  function toast(m) {
    var t = byId('pdc-toast');
    t.textContent = m;
    t.classList.add('on');
    setTimeout(function () { t.classList.remove('on'); }, 3200);
  }

  /* ═══════════════════════════════════════════════════════════
     12bis. GARDER MA CRÉATION (capture email + lien de reprise)
     ─────────────────────────────────────────────────────────
     Sérialise tout l'état du configurateur, pousse les fichiers
     présents sur Cloudinary (URLs durables) et envoie le tout au
     worker (KV 30 j + Klaviyo) → l'utilisateur reçoit un lien
     pour reprendre sa commande plus tard. Attaque le goulot
     configurateur→panier en captant l'email avant l'abandon. */

  /* path d'état porteur de fichier → (type Cloudinary, clé property panier) */
  var SAVE_FILES = [
    { path: 'logo',       t: 'logo',                key: '_Logo source' },
    { path: 'pubf',       t: 'fichier-pub',         key: '_Fichier source' },
    { path: 'pmlogo',     t: 'logo-permis',         key: '_Logo permis source' },
    { path: 'pmf',        t: 'fichier-permis',      key: '_Fichier permis source' },
    { path: 'alogo',      t: 'logo-agence',         key: '_Logo agence source' },
    { path: 'aFile',      t: 'agent-recto',         key: '_Fichier recto' },
    { path: 'aFileVerso', t: 'agent-verso',         key: '_Fichier verso' },
    { path: 'habf',       t: 'visuel-habillage',    key: '_Visuel source' },
    { path: 'immof',      t: 'visuel-grand-format', key: '_Visuel grand format source' }
  ];

  /* Identifiant navigateur stable (rate-limit worker + réconciliation) */
  function saveCid() {
    try {
      var k = 'pdc_cid', v = localStorage.getItem(k);
      if (!v) { v = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem(k, v); }
      return v;
    } catch (e) { return ''; }
  }

  /* Libellé du mode courant (résumé admin/email) */
  function modeLabel() {
    if (state.cat === 'pub') return state.mode === 'ia' ? 'Design IA' : state.mode === 'guide' ? 'Guidé' : state.mode === 'later' ? 'Fichier par mail' : 'Fichier';
    if (state.cat === 'permis') return state.pmMode === 'guide' ? 'Saisie' : state.pmMode === 'later' ? 'Fichier par mail' : 'Fichier';
    if (state.cat === 'agent') return state.aMode === 'guide' ? 'Simulateur' : state.aMode === 'later' ? 'Fichier par mail' : 'Fichier';
    return state.habLater ? 'Fichier par mail' : 'Fichier';
  }

  /* État sérialisable : scalaires + objets simples ; fichiers → URL Cloudinary ; IA → id/chosen */
  function serializeConfig(urls) {
    var clone = {};
    Object.keys(state).forEach(function (k) {
      if (k === 'creaFiles') { clone[k] = []; return; }                 // File[] non repris
      if (k === 'iaLogo' || k === 'iaLogoColor') { clone[k] = ''; return; } // logo non repris (dataURL lourd ; couleur dérivée à l'upload)
      if (k === 'ia') { clone[k] = { id: state.ia.id, chosen: state.ia.chosen }; return; } // props re-fetchées via id
      var isFile = SAVE_FILES.some(function (s) { return s.path === k; });
      if (isFile) { var o = state[k] || {}; clone[k] = { name: o.name || '', cloud: urls[k] || o.cloud || '' }; return; }
      clone[k] = state[k];                                              // scalaires + pm/agency (objets simples)
    });
    return clone;
  }

  /* Restaure l'état depuis une config sauvegardée (fichiers en URL Cloudinary) */
  function applyConfig(cfg) {
    Object.keys(cfg).forEach(function (k) {
      if (k === 'ia' || k === 'creaFiles') return;                      // traités à part
      var isFile = SAVE_FILES.some(function (s) { return s.path === k; });
      if (isFile) { var o = cfg[k] || {}; state[k] = { url: o.cloud || '', file: null, name: o.name || '', cloud: o.cloud || '' }; }
      else state[k] = cfg[k];
    });
    state.creaFiles = [];
    if (cfg.ia && cfg.ia.id) {
      state.ia = { id: cfg.ia.id, props: [], chosen: cfg.ia.chosen != null ? cfg.ia.chosen : -1, busy: false, autoSaved: true };
      fetch('/apps/designer/proposition?id=' + encodeURIComponent(cfg.ia.id))
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.propositions) state.ia.props = d.propositions; })
        .catch(function () {})
        .then(function () { finishRestore(); });
    } else {
      state.ia = { id: null, props: [], chosen: -1, busy: false, autoSaved: false };
      finishRestore();
    }
  }
  function finishRestore() {
    if (['pub', 'permis', 'agent', 'habillage'].indexOf(state.cat) !== -1) pdcSwitch(state.cat);
    else render();
    toast('On a retrouvé votre création ✓');
  }

  /* Rasterise un File SVG en PNG (largeur cap 1200) pour l'aperçu email */
  function svgToPng(svgFile) {
    return new Promise(function (resolve) {
      var rd = new FileReader();
      rd.onload = function () {
        var img = new Image();
        img.onload = function () {
          var w = img.naturalWidth || 1200, h = img.naturalHeight || 800;
          var sc = Math.min(1200 / w, 1) || 1, cw = Math.round(w * sc), ch = Math.round(h * sc);
          var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
          var cx = cv.getContext('2d'); cx.fillStyle = '#fff'; cx.fillRect(0, 0, cw, ch); cx.drawImage(img, 0, 0, cw, ch);
          cv.toBlob(function (b) { resolve(b ? new File([b], 'apercu.png', { type: 'image/png' }) : null); }, 'image/png', 0.9);
        };
        img.onerror = function () { resolve(null); };
        img.src = rd.result;
      };
      rd.onerror = function () { resolve(null); };
      rd.readAsDataURL(svgFile);
    });
  }

  /* URL d'aperçu pour l'email : maquette composée (guidé/IA) sinon 1er visuel client */
  function buildPreviewUrl(urls) {
    if (isGuidedMode()) {
      var svg = getMaquetteSVG();
      if (svg) return svgToPng(svg).then(function (png) { return png ? upload(png, 'apercu', 'maquettes') : null; }).catch(function () { return null; });
    }
    return Promise.resolve(urls.pubf || urls.habf || urls.immof || urls.aFile || urls.pmf || urls.logo || null);
  }

  /* Upload des fichiers présents (comme addCart) → map path→URL */
  function uploadSaveFiles() {
    batchId = batchId || newBatchId();
    var urls = {};
    var seq = Promise.resolve();
    SAVE_FILES.forEach(function (s) {
      var o = state[s.path];
      if (o && o.file && (s.path !== 'aFileVerso' || rvActive())) {
        seq = seq.then(function () { return upload(o.file, s.t, 'sources').then(function (u) { if (u) urls[s.path] = u; }); });
      } else if (o && o.cloud) {
        urls[s.path] = o.cloud;                                         // déjà sur Cloudinary (config reprise)
      }
    });
    return seq.then(function () { return urls; });
  }

  function openSaveModal() {
    var m = byId('pdc-save');
    if (!m) return;
    m.classList.add('on');
    var i = byId('pdc-save-mail');
    if (i) { i.value = state.mail || state.iaEmail || state.agency.mail || ''; i.focus(); }
  }
  function closeSaveModal() { var m = byId('pdc-save'); if (m) m.classList.remove('on'); }

  /* Cœur de la sauvegarde — réutilisé par la modale ET la capture auto du designer IA. */
  function performSave(email) {
    return uploadSaveFiles().then(function (urls) {
      return buildPreviewUrl(urls).then(function (previewUrl) {
        var price = calcPrice();
        var body = {
          email: email,
          config: JSON.stringify(serializeConfig(urls)),
          summary: { categorie: catLabel(), format: fmtLabel(), quantite: totalPanneaux() + (totalPanneaux() > 1 ? ' panneaux' : ' panneau'), prix: price.subtotal + ' € HT', mode: modeLabel() },
          previewUrl: previewUrl || null,
          pageUrl: location.origin + location.pathname,
          cid: saveCid(),
          website: ''
        };
        return fetch('/apps/designer/sauvegarder', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
      });
    });
  }

  function submitSave() {
    var input = byId('pdc-save-mail'), btn = byId('pdc-save-go'), msg = byId('pdc-save-msg');
    var email = ((input && input.value) || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { if (msg) { msg.textContent = 'Indiquez un email valide.'; msg.className = 'pdc-save-msg err'; } return; }
    if (byId('pdc-save-hp') && byId('pdc-save-hp').value) return;        // honeypot
    btn.disabled = true; btn.textContent = 'Envoi…';
    if (msg) { msg.textContent = 'On prépare votre lien…'; msg.className = 'pdc-save-msg'; }
    performSave(email)
      .then(function (d) {
        btn.disabled = false; btn.textContent = 'Recevoir ma configuration';
        if (d && d.ok) {
          if (msg) { msg.textContent = "✓ C'est envoyé ! Vérifiez votre boîte mail."; msg.className = 'pdc-save-msg ok'; }
          toast('Création sauvegardée ✓');
          setTimeout(closeSaveModal, 2600);
        } else if (msg) { msg.textContent = (d && d.error) || 'Un souci est survenu, réessayez.'; msg.className = 'pdc-save-msg err'; }
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Recevoir ma configuration';
        if (msg) { msg.textContent = 'Un souci est survenu, réessayez.'; msg.className = 'pdc-save-msg err'; }
      });
  }

  /* Capture auto : l'email saisi dans le designer IA alimente la relance, une seule
     fois par génération. Le flow Klaviyo exclut déjà ceux qui passent commande. */
  function maybeAutoCaptureIA() {
    var mail = (state.iaEmail || '').trim();
    if (!mail || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) return;
    if (state.ia.autoSaved) return;
    state.ia.autoSaved = true;
    performSave(mail).then(function (d) {
      if (!(d && d.ok)) state.ia.autoSaved = false; // échec → retentable au prochain choix
    }).catch(function () { state.ia.autoSaved = false; });
  }

  /* Injection du bouton secondaire (sous #btn-cart) + de la modale */
  function mountSaveUI() {
    var cart = byId('btn-cart');
    if (cart && !byId('pdc-save-open')) {
      var b = document.createElement('button');
      b.type = 'button'; b.id = 'pdc-save-open'; b.className = 'pdc-save-open';
      b.setAttribute('data-action', 'save-open');
      b.textContent = 'Garder ma création pour plus tard';
      if (cart.parentNode) cart.parentNode.insertBefore(b, cart.nextSibling);
    }
    if (!byId('pdc-save')) {
      var wrap = document.querySelector('.pdc-wrap') || document.body;
      var d = document.createElement('div');
      d.id = 'pdc-save'; d.className = 'pdc-save';
      d.innerHTML =
        '<div class="pdc-save-card" role="dialog" aria-modal="true" aria-labelledby="pdc-save-t">' +
          '<button type="button" class="pdc-save-x" data-action="save-close" aria-label="Fermer">×</button>' +
          '<h3 id="pdc-save-t">Gardez votre création</h3>' +
          '<p>Recevez un lien pour reprendre votre commande quand vous voulez — on garde votre configuration et vos fichiers.</p>' +
          '<input type="email" id="pdc-save-mail" placeholder="votre@email.fr" autocomplete="email" inputmode="email">' +
          '<input type="text" id="pdc-save-hp" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px">' +
          '<button type="button" id="pdc-save-go" class="pdc-save-go" data-action="save-submit">Recevoir ma configuration</button>' +
          '<div id="pdc-save-msg" class="pdc-save-msg"></div>' +
          '<div class="pdc-save-rea">Votre création et vos fichiers sont gardés 7 jours.</div>' +
        '</div>';
      wrap.appendChild(d);
      d.addEventListener('click', function (e) { if (e.target === d) closeSaveModal(); });
    }
  }

  /* ═══════════════════════════════════════════════════════════
     13. WIRING — délégation d'événements (remplace les handlers inline)
     ─────────────────────────────────────────────────────────────
     Correspondance data-action (clic) → handler :
       switch     data-c                         → pdcSwitch
       mask       data-mask                      → setMask
       fmt        data-group,data-w,data-h       → setFormat
       mat        data-group,data-m,data-n       → setMat
       mode       data-mode                      → setMode
       permis-mode data-mode                     → setPermisMode
       hab-type   data-h                         → setHabType
       pack       data-q                         → setPack
       pill       data-group,data-field,data-value → setPillField (orientation)
       sw         data-group,data-field,data-value → setSwatch (couleurs)
       pick       data-input                     → clic input fichier caché
       rm-file    data-file                      → rmFile
       rm-crea    data-idx                       → rmCreaFile
       cart-qty   data-delta                     → chgCartQty
       statut     data-statut,data-delta         → chgStatut
       add-cart                                  → addCart
     Saisie (input) :
       data-field[.path]  + (data-norender pour ne pas re-render) ; data-date pour les dates
     Changement (change) :
       data-check (case à cocher), data-file (input fichier), data-crea-files (multi)
     Glisser-déposer : data-drop="<key>" (ou "__crea")
     ═══════════════════════════════════════════════════════════ */
  /* ═══════════════════════════════════════════════════════════
     DESIGNER IA (mode 'ia' catégorie pub) — appel du Worker
     /apps/designer/generer (App Proxy) + rendu via PDC_DESIGNER
     ═══════════════════════════════════════════════════════════ */
  function iaContact() {
    return { tel: (state.iaTel || '').trim(), email: (state.iaEmail || '').trim() || null };
  }

  function iaEsc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* Barre de progression de génération (~10-12 s) : remplit 92 % en CSS, complétée à la réponse.
     Les messages d'étape tournent toutes les 2,6 s pour montrer que ça travaille. */
  var IA_STEPS = ['Analyse de votre métier…', 'Choix des couleurs…', 'Composition de la mise en page…', 'Écriture des textes…', 'Derniers réglages…'];
  var iaStepTimer = null;
  function iaProgressStart(second) {
    var box = byId(second ? 'ia-progress2' : 'ia-progress'), bar = byId(second ? 'ia-progress2-bar' : 'ia-progress-bar');
    var step = byId(second ? 'ia-progress2-step' : 'ia-progress-step');
    if (!box || !bar) return;
    box.style.display = '';
    bar.style.transition = 'none';
    bar.style.width = '0%';
    void bar.offsetWidth; // reflow → la transition repart de zéro
    bar.style.transition = 'width 14s cubic-bezier(.15,.65,.25,1)';
    bar.style.width = '92%';
    if (step) {
      var k = 0;
      step.textContent = second ? 'Prise en compte de vos précisions…' : IA_STEPS[0];
      clearInterval(iaStepTimer);
      iaStepTimer = setInterval(function () { k = (k + 1) % IA_STEPS.length; step.textContent = IA_STEPS[k]; }, 2600);
    }
    if (box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function iaProgressEnd() {
    clearInterval(iaStepTimer);
    [['ia-progress', 'ia-progress-bar'], ['ia-progress2', 'ia-progress2-bar']].forEach(function (ids) {
      var box = byId(ids[0]), bar = byId(ids[1]);
      if (!box || !bar || box.style.display === 'none') return;
      bar.style.transition = 'width .35s ease-out';
      bar.style.width = '100%';
      setTimeout(function () { box.style.display = 'none'; }, 450);
    });
  }

  /* Pastilles couleur (formulaire + panneau de retouches) — toutes synchronisées sur state.iaCouleur */
  function iaSyncSwatches() {
    document.querySelectorAll('.ia-swc').forEach(function (s) {
      s.classList.toggle('on', (s.dataset.c || '') === (state.iaCouleur || ''));
    });
  }

  /* Précisions de régénération → champ `retouches` du Worker */
  function iaRetouches() {
    var parts = [];
    if ((state.iaRefManque || '').trim()) parts.push('il manque : ' + state.iaRefManque.trim());
    if ((state.iaRefPicto || '').trim()) parts.push('pictogramme souhaité : ' + state.iaRefPicto.trim());
    return parts.join(' · ');
  }

  function iaGenerate() {
    if (state.ia.busy) return;
    if (!window.PDC_DESIGNER) { toast('Module design indisponible — rechargez la page'); return; }
    var nom = (state.iaNom || '').trim(), metier = (state.iaMetier || '').trim(), tel = (state.iaTel || '').trim();
    if (nom.length < 2) { toast('Indiquez le nom de votre entreprise'); return; }
    if (metier.length < 3) { toast('Indiquez votre métier'); return; }
    if (tel.replace(/\D/g, '').length < 9) { toast('Indiquez un téléphone valide (affiché sur le panneau)'); return; }

    var status = byId('ia-status'), btn = byId('ia-gen-btn');
    var isRegen = state.ia.props.length > 0;
    state.ia.busy = true;
    btn.disabled = true;
    btn.textContent = '✨ Création en cours…';
    status.style.display = 'none';
    var refineBox = byId('ia-refine');
    if (isRegen && refineBox) refineBox.style.display = 'none';
    iaProgressStart(isRegen);

    /* Identifiant navigateur persistant pour le rate-limit (l'IP est masquée par l'App Proxy) */
    var cid = '';
    try {
      cid = localStorage.getItem('pdc_cid') || '';
      if (!cid) { cid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (String(Date.now()) + Math.random().toString(16).slice(2)); localStorage.setItem('pdc_cid', cid); }
    } catch (e) { cid = ''; }

    var body = {
      cid: cid || undefined,
      nom: nom, metier: metier, tel: tel,
      ville: (state.iaVille || '').trim() || undefined,
      email: (state.iaEmail || '').trim() || undefined,
      services: (state.iaPrestas || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 8),
      couleur: (state.iaCouleur || '').trim() || undefined,
      style: (state.iaStyle === 'vif' || state.iaStyle === 'sobre') ? state.iaStyle : undefined,
      envies: (state.iaEnvies || '').trim() || undefined,
      retouches: isRegen ? (iaRetouches() || undefined) : undefined,
      precedent: isRegen ? state.ia.props.map(function (p) { return p.layout + '/' + p.palette; }) : undefined,
      website: (byId('ia-website') && byId('ia-website').value) || undefined // honeypot
    };

    fetch('/apps/designer/generer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null; try { j = JSON.parse(t); } catch (e) { /* réponse HTML (proxy/erreur) → pas du JSON */ }
          if (!j) throw new Error('Le designer est très sollicité là, réessayez dans un instant 🙏');
          return { ok: r.ok, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok || (res.j && res.j.error)) throw new Error((res.j && res.j.error) || 'Génération momentanément indisponible — réessayez.');
        state.ia.id = res.j.id;
        state.ia.props = res.j.propositions || [];
        state.ia.chosen = -1;
        state.ia.autoSaved = false; // nouvelle génération → recapturable
        state.iaRefManque = ''; state.iaRefPicto = ''; // précisions consommées
        var ref = byId('ia-refine');
        if (ref) ref.style.display = 'none';
        iaRenderResults();
        var card = byId('ia-results-card');
        if (card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        render();
      })
      .catch(function (e) {
        status.style.display = '';
        status.textContent = '⚠ ' + e.message;
      })
      .then(function () {
        iaProgressEnd();
        state.ia.busy = false;
        btn.disabled = false;
        btn.innerHTML = '<span class="ia-spark">✨</span> Dessiner mes 2 panneaux <span class="ia-spark s2">✦</span>';
      });
  }

  function iaRenderResults() {
    var card = byId('ia-results-card'), grid = byId('ia-results');
    if (!card || !grid) return;
    if (!state.ia.props.length) { card.style.display = 'none'; updateExamplesVisibility(); return; }
    card.style.display = '';
    updateExamplesVisibility();
    var h = '';
    if (state.ia.chosen < 0) {
      h += '<div class="ia-choose">👉 Choisissez l\'une des 2 propositions ci-dessous — c\'est la maquette que nous imprimerons.</div>';
    }
    state.ia.props.forEach(function (p, i) {
      var on = state.ia.chosen === i;
      h += '<div class="ia-prop' + (on ? ' on' : '') + '" data-action="ia-pick" data-idx="' + i + '">' +
        '<span class="ia-tag">' + (on ? '✓ Votre choix' : 'Proposition ' + (i + 1)) + '</span>' +
        '<span class="ia-pick-dot">✓</span>' +
        PDC_DESIGNER.render(p, iaContact(), { watermark: true, logo: state.iaLogo, logoColor: state.iaLogoColor, ratio: iaRatio() }) +
        '<div class="ia-arg">' + iaEsc(p.argumentaire) + '</div></div>';
    });
    if (state.ia.chosen >= 0) {
      h += '<div class="ia-confirm">' +
        '<div class="ia-confirm-t"><b>✓ Design validé&nbsp;!</b> Votre maquette sera imprimée telle quelle, automatiquement avec votre commande.</div>' +
        '<button type="button" class="ia-confirm-btn" data-action="add-cart">Ajouter au panier pour confirmer →</button>' +
        '</div>';
    }
    grid.innerHTML = h;
  }

  function iaPick(i) {
    if (!state.ia.props[i]) return;
    state.ia.chosen = i;
    iaRenderResults();
    toast('Proposition ' + (i + 1) + ' sélectionnée — visible dans l\'aperçu');
    render();
    maybeAutoCaptureIA();
    designerEvt('choix-crea');
  }

  /* Compteur d'usage designer (pilotage) — ne bloque jamais l'UX */
  function designerEvt(type) {
    try {
      var src = '';
      try { src = sessionStorage.getItem('pdc_utm') || ''; } catch (e) {}
      fetch('/apps/designer/evt', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ type: type, src: src }) });
    } catch (e) {}
  }

  var clickActions = {
    'switch': function (el, ds) { pdcSwitch(ds.c); },
    'sc-ia': function () { pdcSwitch('pub'); setMode('ia'); var t = document.querySelector('.pdc-tabs'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); },
    'sc-file': function () { pdcSwitch('pub'); setMode('file'); var t = document.querySelector('.pdc-tabs'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); },
    'mask': function (el, ds) { setMask(ds.mask); },
    'fmt': function (el, ds) { setFormat(el, ds.group); },
    'mat': function (el, ds) { setMat(el, ds.group); },
    'mode': function (el, ds) { setMode(ds.mode); },
    'permis-mode': function (el, ds) { setPermisMode(ds.mode); },
    'permis-type': function (el, ds) { setPermisType(ds.value, el); },
    'agent-mode': function (el, ds) { setAgentMode(ds.mode); },
    'hab-type': function (el, ds) { setHabType(el); },
    'hab-mode': function (el, ds) { setHabMode(ds.mode); },
    'pack': function (el, ds) { setPack(el, parseInt(ds.q)); },
    'pill': function (el, ds) { setPillField(el, ds.group, ds.field, ds.value); },
    'sw': function (el, ds) { setSwatch(el, ds.group, ds.field, ds.value); },
    'pick': function (el, ds) { var inp = byId(ds.input); if (inp) inp.click(); },
    'rm-file': function (el, ds) { rmFile(ds.file); },
    'rm-crea': function (el, ds) { rmCreaFile(parseInt(ds.idx)); },
    'cart-qty': function (el, ds) { chgCartQty(parseInt(ds.delta)); },
    'statut': function (el, ds) { chgStatut(ds.statut, parseInt(ds.delta)); },
    'rv-toggle': function (el, ds) { setRv(ds.rv === '1'); },
    'ia-gen': function () { iaGenerate(); },
    'ia-pick': function (el, ds) { iaPick(parseInt(ds.idx)); },
    'ia-refine-toggle': function () { var r = byId('ia-refine'); if (r) r.style.display = r.style.display === 'none' ? '' : 'none'; },
    'ia-color': function (el, ds) { state.iaCouleur = ds.c || ''; iaSyncSwatches(); },
    'ia-style': function (el, ds) { state.iaStyle = ds.s || 'auto'; document.querySelectorAll('[data-action="ia-style"]').forEach(function (b) { b.classList.toggle('on', b === el); }); },
    'ia-refine-opt': function (el) { var opt = el.closest('.ia-opt'); if (opt) opt.classList.toggle('open'); },
    'add-cart': function (el, ds) { addCart(); },
    'save-open': function () { openSaveModal(); },
    'save-close': function () { closeSaveModal(); },
    'save-submit': function () { submitSave(); }
  };

  function onClick(e) {
    var el = e.target.closest('[data-action]');
    if (!el) return;
    var fn = clickActions[el.dataset.action];
    if (fn) fn(el, el.dataset);
  }

  function onInput(e) {
    var t = e.target;
    if (t.dataset.date != null) { autoDate(t, t.dataset.date); return; }
    if (t.dataset.field != null) {
      setStatePath(t.dataset.field, t.value);
      if (t.dataset.norender == null) render();
    }
  }

  /* Couleur dominante chromatique d'un logo (ignore transparent / blanc / noir / gris). */
  function dominantColor(img) {
    try {
      var n = 48, c = document.createElement('canvas'); c.width = n; c.height = n;
      var cx = c.getContext('2d'); cx.drawImage(img, 0, 0, n, n);
      var d = cx.getImageData(0, 0, n, n).data, r = 0, g = 0, b = 0, k = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 128) continue;                       // transparent
        var rr = d[i], gg = d[i + 1], bb = d[i + 2];
        var mx = Math.max(rr, gg, bb), mn = Math.min(rr, gg, bb);
        if (mx > 240 && mn > 240) continue;                 // blanc
        if (mx < 20) continue;                              // noir
        if (mx - mn < 22) continue;                         // gris/neutre → on veut la couleur de marque
        r += rr; g += gg; b += bb; k++;
      }
      if (!k) return '';                                    // logo sans couleur → on garde la palette IA
      var to = function (v) { return ('0' + Math.round(v / k).toString(16)).slice(-2); };
      return '#' + to(r) + to(g) + to(b);
    } catch (e) { return ''; }                              // image non lisible
  }

  /* Logo client optionnel pour le designer IA → dataURL embarqué + accord couleur, re-render. */
  function handleIaLogo(inp) {
    var f = inp.files && inp.files[0];
    if (!f) { state.iaLogo = ''; state.iaLogoColor = ''; if (state.ia.props.length) iaRenderResults(); render(); return; }
    var rd = new FileReader();
    rd.onload = function () {
      state.iaLogo = rd.result;
      var img = new Image();
      img.onload = function () { state.iaLogoColor = dominantColor(img); if (state.ia.props.length) iaRenderResults(); render(); };
      img.onerror = function () { state.iaLogoColor = ''; if (state.ia.props.length) iaRenderResults(); render(); };
      img.src = rd.result;
    };
    rd.readAsDataURL(f);
  }

  function onChange(e) {
    var t = e.target;
    if (t.dataset.check != null) { state[t.dataset.check] = t.checked; render(); return; }
    if (t.dataset.iaLogo != null) { handleIaLogo(t); return; }
    if (t.dataset.creaFiles != null) { handleCreaFiles(t); return; }
    if (t.dataset.file != null) { handleFile(t, t.dataset.file); return; }
  }

  function onDragOver(e) {
    var z = e.target.closest('[data-drop]');
    if (z) { e.preventDefault(); z.classList.add('drag'); }
  }
  function onDragLeave(e) {
    var z = e.target.closest('[data-drop]');
    if (z) z.classList.remove('drag');
  }
  function onDrop(e) {
    var z = e.target.closest('[data-drop]');
    if (!z) return;
    e.preventDefault();
    z.classList.remove('drag');
    var files = e.dataTransfer && e.dataTransfer.files;
    if (!files) return;
    if (z.dataset.drop === '__crea') {
      for (var i = 0; i < files.length; i++) state.creaFiles.push(files[i]);
      renderCreaList();
    } else if (files[0]) {
      handleFile({ files: files }, z.dataset.drop);
    }
  }

  function wireEvents(root) {
    root.addEventListener('click', onClick);
    root.addEventListener('input', onInput);
    root.addEventListener('change', onChange);
    root.addEventListener('dragover', onDragOver);
    root.addEventListener('dragleave', onDragLeave);
    root.addEventListener('drop', onDrop);
  }

  /* ═══════════════════════════════════════════════════════════
     14. INIT — routing ?cat= + premier render
     ═══════════════════════════════════════════════════════════ */
  /* Galerie « Ce que l'IA peut créer » — rendus par le moteur PDC_DESIGNER (sans filigrane, ce sont des exemples vitrine) */
  var IA_EXAMPLES = [
    [{ layout: 'diagonal', palette: 'elec', picto: 'elec', nom: 'DUPONT ÉLEC', metier: 'Électricité générale', services: [], ville: 'Annecy', slogan: 'Dépannage 7j/7', badge: 'Devis gratuit !', qr: false }, { tel: '06 98 76 54 32', email: null }],
    [{ layout: 'picto-central', palette: 'paysagiste', picto: 'paysagiste', nom: 'VERT & JARDIN', metier: 'Paysagiste', services: [], ville: 'Aix-les-Bains', slogan: 'Création & entretien', qr: false }, { tel: '06 55 44 33 22', email: null }],
    [{ layout: 'split', palette: 'nettoyage-toiture', picto: 'nettoyage-toiture', titre: 'Travaux réalisés par', nom: 'TOIT NET', metier: 'Nettoyage toiture', services: ['Démoussage', 'Hydrofuge', 'Façade'], ville: 'Chambéry', qr: true }, { tel: '06 23 45 67 89', email: 'contact@toit-net.fr' }],
    [{ layout: 'classique', palette: 'plomberie', picto: 'plomberie', nom: 'AQUA SERVICES', metier: 'Plomberie · Chauffage', services: ['Dépannage', 'Salle de bains', 'Chauffage'], ville: 'Annecy', badge: 'Devis gratuit !', qr: false }, { tel: '06 11 22 33 44', email: null }],
    [{ layout: 'minimal', palette: 'menuiserie', picto: 'menuiserie', nom: 'ATELIER ROUX', metier: 'Menuiserie', services: [], ville: 'Lyon', slogan: 'Fabrication française', qr: false }, { tel: '04 79 00 00 00', email: null }],
    [{ layout: 'diagonal', palette: 'forestier', picto: 'forestier', nom: 'BOIS DES CIMES', metier: 'Exploitant forestier', services: [], ville: 'Moûtiers', slogan: 'Gestion durable', qr: false }, { tel: '06 78 90 12 34', email: null }]
  ];
  function renderIaExamples() {
    var el = byId('ia-examples');
    if (!el || typeof window.PDC_DESIGNER === 'undefined') return;
    el.innerHTML = IA_EXAMPLES.map(function (e) {
      return '<div class="ia-ex">' + PDC_DESIGNER.render(e[0], e[1], { watermark: false }) + '</div>';
    }).join('');
  }

  /* Showcase hero « ce qu'on sait faire » — 3 gabarits contrastés (preuve), rendus par PDC_DESIGNER. [prop, contact, légende] */
  var SHOWCASE_EXAMPLES = [
    [{ layout: 'classique', palette: 'gros-oeuvre', picto: 'gros-oeuvre', titre: 'Travaux réalisés par', nom: 'MARTIN BÂTIMENT', metier: 'Maçonnerie générale', services: ['Gros œuvre', 'Fondations', 'Dalles béton', 'Murs en parpaing'], ville: 'Lyon', slogan: 'Devis gratuit · Intervention rapide', badge: 'Devis gratuit !', qr: true }, { tel: '06 12 34 56 78', email: 'contact@martin-batiment.fr' }, 'Maçonnerie · gros œuvre'],
    [{ layout: 'diagonal', palette: 'plomberie', picto: 'plomberie', nom: 'AQUA CONFORT', metier: 'Plomberie · Chauffage', services: ['Dépannage', 'Sanitaire', 'Chaudières'], ville: 'Nantes', slogan: 'Dépannage rapide · Devis gratuit', qr: true }, { tel: '06 23 45 67 89', email: 'contact@aqua-confort.fr' }, 'Plomberie · chauffage'],
    [{ layout: 'picto-central', palette: 'paysagiste', picto: 'paysagiste', nom: 'JARDINS DU SUD', metier: 'Paysagiste', services: ['Création de jardins', 'Élagage', 'Clôtures'], ville: 'Bordeaux', slogan: 'Aménagement extérieur sur mesure', badge: 'Devis gratuit !', qr: true }, { tel: '06 34 56 78 90', email: 'contact@jardins-du-sud.fr' }, 'Paysagiste · aménagement']
  ];
  /* Une fois les 2 propositions générées, on masque NOS exemples (showcase + carte
     « ce que l'IA peut créer ») pour que l'attention aille au choix du client. */
  function updateExamplesVisibility() {
    var hasProps = state.ia.props.length > 0;
    var sc = document.querySelector('.pdc-showcase');
    if (sc) sc.style.display = (state.cat === 'pub' && !hasProps) ? '' : 'none';
    var ex = byId('ia-examples-card');
    if (ex) ex.style.display = hasProps ? 'none' : '';
  }

  function renderShowcase() {
    var el = byId('pdc-showcase');
    if (!el || typeof window.PDC_DESIGNER === 'undefined') return;
    el.innerHTML = SHOWCASE_EXAMPLES.map(function (e) {
      return '<div class="pdc-sc-card"><div class="pdc-sc-frame">' + PDC_DESIGNER.render(e[0], e[1], { watermark: false }) + '</div><div class="pdc-sc-cap">' + e[2] + '</div></div>';
    }).join('');
  }

  function init() {
    var root = document.querySelector('.pdc-wrap');
    if (!root) return;
    wireEvents(root);
    renderIaExamples();
    renderShowcase();
    mountSaveUI();
    /* Mémorise la source d'acquisition (utm) pour les compteurs designer */
    try {
      var utm = new URLSearchParams(window.location.search).get('utm_source');
      if (utm) sessionStorage.setItem('pdc_utm', utm.replace(/[^a-z0-9_-]/gi, '').slice(0, 24));
    } catch (e) {}
    try {
      var params = new URLSearchParams(window.location.search);
      var reprise = params.get('reprise');
      if (reprise && /^[0-9a-f-]{36}$/.test(reprise)) {
        fetch('/apps/designer/reprise?id=' + encodeURIComponent(reprise))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && !d.error && d.config) { try { applyConfig(JSON.parse(d.config)); return; } catch (e) { /* tombe sur le render neuf */ } }
            render(); toast('Lien expiré — on repart à neuf.');
          })
          .catch(function () { render(); });
        return;
      }
      var cat = params.get('cat');
      if (cat && ['pub', 'permis', 'agent', 'habillage'].indexOf(cat) !== -1) {
        pdcSwitch(cat);
        return;
      }
    } catch (e) { /* noop */ }
    render();
  }

  init();
})();
